
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("dgOrd", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc348fb5bec9260f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $b8OI0 = parcelRequire("b8OI0");

var $eSnSE = parcelRequire("eSnSE");

var $5qPoO = parcelRequire("5qPoO");

var $ixiAQ = parcelRequire("ixiAQ");


var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $hu0Oo = parcelRequire("hu0Oo");

var $fYeTG = parcelRequire("fYeTG");

var $RXvVX = parcelRequire("RXvVX");

var $84DOT = parcelRequire("84DOT");

var $jipjz = parcelRequire("jipjz");

var $dRfS0 = parcelRequire("dRfS0");

var $dkTXM = parcelRequire("dkTXM");

var $kh7bJ = parcelRequire("kh7bJ");

var $eJrcF = parcelRequire("eJrcF");

var $eU7vk = parcelRequire("eU7vk");


var $4pSRi = parcelRequire("4pSRi");

var $4NkR0 = parcelRequire("4NkR0");

var $kO1ht = parcelRequire("kO1ht");

var $cgeq2 = parcelRequire("cgeq2");

var $3nihz = parcelRequire("3nihz");

var $4BIvh = parcelRequire("4BIvh");

var $72yuq = parcelRequire("72yuq");

var $9HAHw = parcelRequire("9HAHw");

var $eqj3a = parcelRequire("eqj3a");
const $cc348fb5bec9260f$var$noop = ()=>undefined;
const $cc348fb5bec9260f$var$onResetApolloCache = ()=>(0, $eU7vk.resetCache)((0, $bd25ba88693dbfbe$export$9c9ee93e509f8666));
const $cc348fb5bec9260f$var$Create = ({ AkCreate: AkCreate = (0, $cgeq2.Create), NudgeTooltip: NudgeTooltip = (0, $dkTXM.NavigationCreateIssueButtonWrapperNudgeAsync), onCreateClick: onCreateClick = (0, $ixiAQ.default), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $4BIvh.useNavigationItemAnalytics), useIsInitialLoadLegacyIssueCreate: // @ts-expect-error - TS2339 - Property 'useIsInitialLoadLegacyIssueCreate' does not exist on type 'CreateProps'.
useIsInitialLoadLegacyIssueCreate = (0, $5qPoO.useIsInitialLoadLegacyIssueCreate) })=>{
    const testId = (0, $RXvVX.testIdGenerate)('create');
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $jipjz.useTriggerIssueCreateModal)();
    (0, $hu0Oo.useInitializePersistentIssueCreateModalView)();
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $kO1ht.NAVIGATION_ITEM_ID).CREATE
    });
    const [{ isInitialLoad: isInitialLoad }, actions] = useIsInitialLoadLegacyIssueCreate();
    let currentIssueCreateVisibility = null;
    const gicOptInStateOverridden = (0, $eJOHy.useRef)(false);
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    const isMobileExperienceEnabled = (0, $fYeTG.isMobileAndInMvpOrExistingUsersExperiment)();
    // TODO: delete this code for clean up issue-create-stop-using-gicoptinstatusresources
    if ((0, $4cTDP.fg)('render_modern_global_issue_create_modal_experience')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { data: data, update: update } = (0, $eJrcF.useResource)((0, $dRfS0.gicOptInStatusResources));
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eJOHy.useLayoutEffect)(()=>{
            if (isAnonymous && !gicOptInStateOverridden.current) {
                update(()=>({
                        gicOptInStatus: {
                            isEnabled: true
                        }
                    }));
                gicOptInStateOverridden.current = true;
            }
        }, [
            isAnonymous,
            update
        ]);
        currentIssueCreateVisibility = data && data?.gicOptInStatus;
    }
    const onClick = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
    (e)=>{
        if ((0, $4cTDP.fg)('render_modern_global_issue_create_modal_experience')) {
            if ((0, $4cTDP.fg)('issue-create-stop-using-gicoptinstatusresources')) {
                (0, $72yuq.GlobalIssueCreateFromTopNav).abort({
                    force: true
                });
                (0, $72yuq.GlobalIssueCreateFromTopNav).start();
                (0, $72yuq.GlobalIssueCreateFromTopNav).addMetadata({
                    inputDelay: Math.round(performance.now() - e.timeStamp)
                });
                const nextState = {
                    disableCreationSuccessFlag: (0, $eqj3a.shouldDisableGICFlagCreation)(),
                    triggerPointKey: (0, $84DOT.GENERIC_GLOBAL_CREATE_BUTTON),
                    ...isMobileExperienceEnabled ? {
                        displayMinimizableButtons: false,
                        displayCreateAnotherIssueToggle: false,
                        triggerPointKey: (0, $84DOT.MOBILE_GLOBAL_CREATE_BUTTON)
                    } : {}
                };
                openIssueCreateModal(nextState);
            } else if (currentIssueCreateVisibility !== null) {
                if (currentIssueCreateVisibility.isEnabled) {
                    (0, $72yuq.GlobalIssueCreateFromTopNav).abort({
                        force: true
                    });
                    (0, $72yuq.GlobalIssueCreateFromTopNav).start();
                    (0, $72yuq.GlobalIssueCreateFromTopNav).addMetadata({
                        inputDelay: Math.round(performance.now() - e.timeStamp)
                    });
                    const nextState = {
                        disableCreationSuccessFlag: (0, $eqj3a.shouldDisableGICFlagCreation)(),
                        triggerPointKey: (0, $84DOT.GENERIC_GLOBAL_CREATE_BUTTON),
                        ...isMobileExperienceEnabled ? {
                            displayMinimizableButtons: false,
                            displayCreateAnotherIssueToggle: false,
                            triggerPointKey: (0, $84DOT.MOBILE_GLOBAL_CREATE_BUTTON)
                        } : {}
                    };
                    openIssueCreateModal(nextState);
                } else {
                    onCreateClick({
                        isInitialLoad: isInitialLoad,
                        triggerSource: (0, $8b9f565bf0bbac99$export$d983e94cf86f65d)
                    });
                    if (isInitialLoad) actions.clearInitialLoaded();
                }
            } else (0, $eSnSE.default).safeErrorWithoutCustomerData('global-issue-create', 'visibility data is still getting downloaded');
        } else {
            onCreateClick({
                isInitialLoad: isInitialLoad,
                triggerSource: (0, $8b9f565bf0bbac99$export$d983e94cf86f65d)
            });
            if (isInitialLoad) actions.clearInitialLoaded();
        }
        triggerAnalytics();
    }, [
        actions,
        currentIssueCreateVisibility,
        isInitialLoad,
        isMobileExperienceEnabled,
        onCreateClick,
        openIssueCreateModal,
        triggerAnalytics
    ]);
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(NudgeTooltip, null, (0, $4cTDP.fg)('create_work_item_modernization') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b8OI0.PopupTrigger), {
        entryPoint: (0, $4pSRi.createPopupEntryPoint),
        entryPointProps: {
            onResetApolloCache: $cc348fb5bec9260f$var$onResetApolloCache
        },
        placement: "bottom-end",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null),
        shouldRenderToParent: true,
        popupComponent: (0, $4NkR0.CreatePopupContainer),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AkCreate, {
                ...triggerProps,
                onClick: onClick,
                text: formatMessage((0, $9HAHw.default).create),
                testId: testId,
                label: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $9HAHw.default).createButtonAriaLabelIssueTermRefresh : (0, $9HAHw.default).createButtonAriaLabel)
            })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AkCreate, {
        onClick: onClick,
        text: formatMessage((0, $9HAHw.default).create),
        testId: testId,
        label: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $9HAHw.default).createButtonAriaLabelIssueTermRefresh : (0, $9HAHw.default).createButtonAriaLabel)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AkCreate, {
        onClick: $cc348fb5bec9260f$var$noop,
        text: formatMessage((0, $9HAHw.default).create),
        testId: testId,
        label: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $9HAHw.default).createButtonAriaLabelIssueTermRefresh : (0, $9HAHw.default).createButtonAriaLabel)
    });
};
const $cc348fb5bec9260f$var$CreateWithErrorBoundary = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nihz.TopLevelErrorBoundary), {
        id: (0, $kO1ht.NAVIGATION_ITEM_ID).CREATE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cc348fb5bec9260f$var$Create, props));
var $cc348fb5bec9260f$export$2e2bcd8739ae039 = $cc348fb5bec9260f$var$CreateWithErrorBoundary;

});
parcelRegister("5qPoO", function(module, exports) {
$parcel$export(module.exports, "useIsInitialLoadLegacyIssueCreate", () => $62891830fba96f35$export$8a73e89ffc4b9342);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $62891830fba96f35$var$initialState = {
    isInitialLoad: true
};
const $62891830fba96f35$export$e324594224ef24da = {
    clearInitialLoaded: ()=>({ setState: setState, getState: getState })=>{
            if (getState().isInitialLoad) setState({
                isInitialLoad: false
            });
        }
};
const $62891830fba96f35$var$store = (0, $GtRbT.createStore)({
    name: 'is-initial-load-create-issue-legacy',
    initialState: $62891830fba96f35$var$initialState,
    actions: $62891830fba96f35$export$e324594224ef24da
});
const $62891830fba96f35$export$8a73e89ffc4b9342 = (0, $iJq0l.createHook)($62891830fba96f35$var$store);

});

parcelRegister("ixiAQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d65f09fde2c4e2e$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $gjeS9 = parcelRequire("gjeS9");

var $4cTDP = parcelRequire("4cTDP");

var $kxCpN = parcelRequire("kxCpN");
const $8d65f09fde2c4e2e$var$onCreateClick = ({ timeout: timeout, tentatives: tentatives, isInitialLoad: // isInitialLoad tracks the initial render of global issue create dialog through this entry point (presently called from navigation create button and keyboard shortcut)
isInitialLoad, triggerSource: triggerSource, showModern: showModern } = {})=>{
    (0, $kxCpN.sendStartMarkForLegacyIssueCreate)({
        isInitialLoad: isInitialLoad,
        triggerSource: triggerSource
    });
    // eslint-disable-next-line jira/wrm/no-load-bridge
    return (0, $gjeS9.loadBridge)({
        name: 'quick-edit/init/create-dialogs',
        wrmKeys: [
            'wrc!com.atlassian.jira.jira-quick-edit-plugin:quick-create-issue-bootstrap',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs'
        ],
        timeout: timeout,
        tentatives: tentatives
    }).then((api)=>{
        if ((0, $4cTDP.fg)('render_modern_global_issue_create_modal_experience')) {
            if (showModern === true) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            api?.hideLoadingIndicator(false);
            else // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            api?.showCreateDialog({
                showModern: showModern
            });
        } else // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        api?.showCreateDialog({});
        (0, $kxCpN.sendEndMarkForLegacyIssueCreate)({
            isInitialLoad: isInitialLoad
        });
    });
};
var $8d65f09fde2c4e2e$export$2e2bcd8739ae039 = $8d65f09fde2c4e2e$var$onCreateClick;

});
parcelRegister("gjeS9", function(module, exports) {
$parcel$export(module.exports, "loadBridge", () => $b5b36a00cf4f19d9$export$df8409da353bde5a);

var $ej5JA = parcelRequire("ej5JA");
var $1HTZw = parcelRequire("1HTZw");
var $agkbU = parcelRequire("agkbU");
var $97BGz = parcelRequire("97BGz");

var $agkbU = parcelRequire("agkbU");
var $97BGz = parcelRequire("97BGz");
var $iyT45 = parcelRequire("iyT45");
var $4T9yL = parcelRequire("4T9yL");
var $ligZL = parcelRequire("ligZL");
var $jb3ni = parcelRequire("jb3ni");
const $b5b36a00cf4f19d9$export$df8409da353bde5a = ({ name: name, wrmKeys: wrmKeys, tentatives: tentatives = (0, $ej5JA.MAX_RETRIES), timeout: timeout = (0, $ej5JA.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR) })=>{
    if (wrmKeys != null) return (0, $97BGz.loadBridgeStrict)({
        name: name,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        wrmKeys: [].concat(wrmKeys),
        shouldLogError: shouldLogError
    });
    if (tentatives <= 0) return Promise.reject(new Error('Unable to load bridge, zero tentatives never works'));
    if (tentatives <= 1) return (0, $1HTZw.loadBridgeBail)({
        name: name,
        shouldLogError: shouldLogError
    });
    return (0, $agkbU.loadBridgeRace)({
        name: name,
        shouldLogError: shouldLogError,
        timeout: (tentatives - 1) * timeout
    });
};

});
parcelRegister("ej5JA", function(module, exports) {
$parcel$export(module.exports, "safeErrorWithoutCustomerData", () => $98246445188fd0a7$export$f19a2d31722e3428);
$parcel$export(module.exports, "MAX_RETRIES", () => $98246445188fd0a7$export$1f86472c1374185a);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $98246445188fd0a7$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "SHOULD_LOG_ERROR", () => $98246445188fd0a7$export$37f20f0ff732fcd7);

var $eSnSE = parcelRequire("eSnSE");
const { safeErrorWithoutCustomerData: $98246445188fd0a7$export$f19a2d31722e3428, safeInfoWithoutCustomerData: $98246445188fd0a7$export$ea810ce67e3c8eac } = (0, $eSnSE.default);
const $98246445188fd0a7$export$1f86472c1374185a = 40;
const $98246445188fd0a7$export$7bd623b29ec8e1eb = 500;
const $98246445188fd0a7$export$37f20f0ff732fcd7 = true;

});

parcelRegister("1HTZw", function(module, exports) {
$parcel$export(module.exports, "loadBridgeBail", () => $d7bbb28cab06ad5d$export$a036f92c2465504e);

var $e5Kmg = parcelRequire("e5Kmg");

var $ej5JA = parcelRequire("ej5JA");
const $d7bbb28cab06ad5d$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR) })=>{
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $ej5JA.safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, $e5Kmg.safeStringify)(error) ?? ''}`, {
            isSpa: __SPA__,
            name: name,
            error: (0, $e5Kmg.safeStringify)(error)
        });
        throw new Error(`Unable to load bridge "${name}"`, {
            cause: error
        });
    }
};

});
parcelRegister("e5Kmg", function(module, exports) {
$parcel$export(module.exports, "safeStringify", () => $96d63f174879aa42$export$56831a8b9cb27763);
/**
 * Stringifies a JS object for logging.
 * @param object
 * @returns {string}
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $96d63f174879aa42$export$56831a8b9cb27763 = (object)=>{
    if (!object) return '';
    if (object instanceof Error) return object.stack || object.message;
    return JSON.stringify(object, Object.getOwnPropertyNames(object));
};

});


parcelRegister("agkbU", function(module, exports) {
$parcel$export(module.exports, "loadBridgeRace", () => $224e973e4c93da11$export$20c32b4579d78b92);

var $1HTZw = parcelRequire("1HTZw");

var $iyT45 = parcelRequire("iyT45");

var $ej5JA = parcelRequire("ej5JA");
const $224e973e4c93da11$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, $ej5JA.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR) })=>Promise.race([
        (0, $iyT45.loadBridgeWeak)({
            name: name
        }),
        new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, $1HTZw.loadBridgeBail)({
                name: name,
                shouldLogError: shouldLogError
            }))
    ]);

});
parcelRegister("iyT45", function(module, exports) {
$parcel$export(module.exports, "loadBridgeWeak", () => $f6004e9afa2128c3$export$3cefda82396756a1);

var $6M1XZ = parcelRequire("6M1XZ");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $f6004e9afa2128c3$var$pollingSingleton = null;
const $f6004e9afa2128c3$export$3cefda82396756a1 = ({ name: name })=>{
    const getter = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $f6004e9afa2128c3$var$pollingSingleton ?? (0, $6M1XZ.createPollingCollection)((v)=>window.require(v), 100);
    $f6004e9afa2128c3$var$pollingSingleton = getter;
    return getter(name);
};

});
parcelRegister("6M1XZ", function(module, exports) {
$parcel$export(module.exports, "createPollingCollection", () => $0a667df7ad6c937e$export$f163446a982a8077);

var $gRw8I = parcelRequire("gRw8I");

var $2oJXr = parcelRequire("2oJXr");
const $0a667df7ad6c937e$export$f163446a982a8077 = (fn, timeout)=>{
    (0, $gRw8I.di)(setTimeout);
    let isPolling = false;
    // Deferred instance is retained for polling
    const deferredMap = new Map();
    // Promise is derived from Deferred and is retained indefinitely
    const promiseMap = new Map();
    // Provided fn will throw until ready, once ready we will resolve and delete the Deferred
    const evaluateForKey = (key)=>{
        let result;
        try {
            result = fn(key);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return;
        }
        const deferred = deferredMap.get(key);
        if (deferred instanceof (0, $2oJXr.default)) {
            deferred.resolve(result);
            deferredMap.delete(key);
        }
    };
    const maybePoll = ()=>{
        if (!isPolling && deferredMap.size > 0) {
            isPolling = true;
            setTimeout(()=>{
                isPolling = false;
                [
                    ...deferredMap.keys()
                ].forEach(evaluateForKey);
                maybePoll();
            }, timeout);
        }
    };
    const getter = (key)=>{
        if (!promiseMap.has(key)) {
            const deferred = new (0, $2oJXr.default)();
            const promise = deferred.then((v)=>v);
            deferredMap.set(key, deferred);
            promiseMap.set(key, promise);
            evaluateForKey(key);
            maybePoll();
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return promiseMap.get(key);
    };
    return getter;
};

});
parcelRegister("2oJXr", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b7015c609345acf$export$2e2bcd8739ae039);
// @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
class $3b7015c609345acf$export$2e2bcd8739ae039 extends Promise {
    // go/jfe-eslint
    static resolve(v) {
        const instance = new $3b7015c609345acf$export$2e2bcd8739ae039();
        instance.resolve(v);
        return instance;
    }
    // go/jfe-eslint
    static reject(e) {
        const instance = new $3b7015c609345acf$export$2e2bcd8739ae039();
        instance.reject(e);
        return instance;
    }
    constructor(){
        // Promise.prototype.then() must be able to call new Deferred(fn)
        // @see https://stackoverflow.com/a/48159603
        // by using arguments flow will ensure we cannot instantiate with constructor parameters
        // eslint-disable-next-line prefer-rest-params
        const [fn] = Array.prototype.slice.call(arguments);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const callbacks = [];
        super(fn ?? callbacks.push.bind(callbacks));
        this.#resolve = callbacks[0];
        this.#reject = callbacks[1];
    }
    #resolve;
    #reject;
    resolve(v) {
        this.#resolve?.(v);
    }
    reject(e) {
        this.#reject?.(e);
    }
}

});




parcelRegister("97BGz", function(module, exports) {
$parcel$export(module.exports, "loadBridgeStrict", () => $32e00fb40c944769$export$eba600d28decc4ac);

var $es5G8 = parcelRequire("es5G8");

var $4cTDP = parcelRequire("4cTDP");

var $bXaxC = parcelRequire("bXaxC");

var $agkbU = parcelRequire("agkbU");

var $7rBE0 = parcelRequire("7rBE0");

var $ej5JA = parcelRequire("ej5JA");

var $4T9yL = parcelRequire("4T9yL");
const $32e00fb40c944769$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR), isolatedFromHeritage: isolatedFromHeritage = false })=>{
    (0, $bXaxC.saveStats)(name, wrmKeys);
    if (!isolatedFromHeritage && (0, $4cTDP.fg)('jfp_magma_jira-report-early-strict-bridge')) {
        if (!(0, $4T9yL.isWRMHeritageLoaded)()) (0, $es5G8.captureException)(`loadBridgeStrict:${name}`, new Error('Do not call loadBridgeStrict without waitForHeritage'));
    }
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await (0, $7rBE0.loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
        return (0, $agkbU.loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError
        });
    }
};

});
parcelRegister("bXaxC", function(module, exports) {
$parcel$export(module.exports, "saveStats", () => $f1ca263307f66278$export$9ea3ff7978093559);
const $f1ca263307f66278$var$incrementResourceStats = (resource, stats)=>{
    if (stats[resource] == null) // eslint-disable-next-line no-param-reassign
    stats[resource] = 1;
    else // eslint-disable-next-line no-param-reassign
    stats[resource] += 1;
};
const $f1ca263307f66278$var$getEmptyLoadBridgeStats = ()=>({
        requests: 0,
        amdModules: {},
        wrmKeys: {}
    });
const $f1ca263307f66278$var$initStats = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__WRM_INTERNAL_STATS__ == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__ = {
        loadBridge: $f1ca263307f66278$var$getEmptyLoadBridgeStats()
    };
    else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__.loadBridge = $f1ca263307f66278$var$getEmptyLoadBridgeStats();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WRM_INTERNAL_STATS__.loadBridge;
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $f1ca263307f66278$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
const $f1ca263307f66278$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
    try {
        const stats = $f1ca263307f66278$var$initStats();
        // stop accumulating stats at TTI mark
        if ($f1ca263307f66278$var$isPageInteractive()) return;
        stats.requests += 1;
        $f1ca263307f66278$var$incrementResourceStats(amdModuleName, stats.amdModules);
        if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$f1ca263307f66278$var$incrementResourceStats(wrmKey, stats.wrmKeys));
        else if (wrmKeys != null) $f1ca263307f66278$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // not critical functionality
    }
};

});

parcelRegister("7rBE0", function(module, exports) {
$parcel$export(module.exports, "loadWrmResources", () => $09f989d08b38b1cb$export$6cda16b6eff75f59);

var $e5Kmg = parcelRequire("e5Kmg");

var $b6X3x = parcelRequire("b6X3x");

var $iyT45 = parcelRequire("iyT45");

var $ej5JA = parcelRequire("ej5JA");
const $09f989d08b38b1cb$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
    const isPrefetch = 'batchUrl' in options;
    let newWrmKeys = wrmKeys;
    try {
        const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
        const wrmRequireModule = await (0, $iyT45.loadBridgeWeak)({
            name: name
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
        // @ts-expect-error - TS2322 - Type 'string | string[]' is not assignable to type 'string[]'.
        newWrmKeys = (0, $b6X3x.prependSuperBatchDepsOnce)(wrmKeys);
        if (isPrefetch) return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $ej5JA.safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
            isSpa: __SPA__,
            wrmKeys: JSON.stringify(newWrmKeys),
            error: (0, $e5Kmg.safeStringify)(error)
        });
        throw new Error('Unable to load wrm resource', {
            cause: error
        });
    }
};

});
parcelRegister("b6X3x", function(module, exports) {
$parcel$export(module.exports, "prependSuperBatchDepsOnce", () => $aa5ee41b24db8c96$export$93d9db5fbabad1b0);

var $avFP5 = parcelRequire("avFP5");
let $aa5ee41b24db8c96$var$isSuperBatchDependenciesLoaded = false;
const $aa5ee41b24db8c96$var$isOnRapidBoardsPage = ()=>{
    const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
    const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href.includes('secure/RapidBoard.jspa');
};
const $aa5ee41b24db8c96$export$93d9db5fbabad1b0 = (wrmKeys)=>{
    // These usually need injecting before most domain-specific deps but in rapidboards they load a
    // smaller set of the needed deps internally early and delay the rest
    if ($aa5ee41b24db8c96$var$isSuperBatchDependenciesLoaded || $aa5ee41b24db8c96$var$isOnRapidBoardsPage()) return wrmKeys;
    $aa5ee41b24db8c96$var$isSuperBatchDependenciesLoaded = true;
    return (0, $avFP5.jiraSuperBatchDependencies).concat(wrmKeys);
};

});
parcelRegister("avFP5", function(module, exports) {
$parcel$export(module.exports, "jiraSuperBatchDependencies", () => $00f9be664c96bf5d$export$f14a6b583ce9e077);
const $00f9be664c96bf5d$export$f14a6b583ce9e077 = [
    // SKATE HAS TO COME FIRST OR ELSE THE OTHER MODULES WILL FAIL
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:util-lite',
    'wrc!jira.webresources:util',
    'wrc!jira.webresources:feature-flags',
    'wrc!jira.webresources:dialogs',
    'wrc!jira.webresources:jira-global',
    'wrc!com.atlassian.auiplugin:aui-spinner'
];

});



parcelRegister("4T9yL", function(module, exports) {
$parcel$export(module.exports, "isWRMHeritageLoaded", () => $ba1950b07a7f2989$export$1a2b9c2d0a3d83ed);
$parcel$export(module.exports, "waitForHeritage", () => $ba1950b07a7f2989$export$c61060338d026f78);

var $hpZoI = parcelRequire("hpZoI");

var $2oJXr = parcelRequire("2oJXr");
let $ba1950b07a7f2989$var$heritageIsLoaded = false;
const $ba1950b07a7f2989$export$1a2b9c2d0a3d83ed = ()=>$ba1950b07a7f2989$var$heritageIsLoaded;
const $ba1950b07a7f2989$export$c61060338d026f78 = ()=>{
    if (false) // WRM is not used on server
    // return null because we don't want to ?.then() chain into loadBridge functions
    return null;
    if (!__SPA__) // Heritage remainder is an SPA concept
    // return promise because we want to ?.then() chain into loadBridge functions
    return Promise.resolve();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.__WAIT_FOR_HERITAGE__) {
        $ba1950b07a7f2989$var$heritageIsLoaded = false;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WAIT_FOR_HERITAGE__ = new (0, $2oJXr.default)();
        (0, $hpZoI.bootstrapWrmClient)().then(()=>{
            $ba1950b07a7f2989$var$heritageIsLoaded = true;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.__WAIT_FOR_HERITAGE__.resolve();
        });
    }
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WAIT_FOR_HERITAGE__;
};

});
parcelRegister("hpZoI", function(module, exports) {
$parcel$export(module.exports, "bootstrapWrmClient", () => $027e7c56f31b7541$export$d001f71dd306cb0c);

var $e5Kmg = parcelRequire("e5Kmg");

var $hgi0g = parcelRequire("hgi0g");

var $9pTd3 = parcelRequire("9pTd3");
const $027e7c56f31b7541$var$SPA_WRM_CONTEXT_ENDPOINT = '/rest/frontend/1/spawrmcontext';
const $027e7c56f31b7541$var$fetchSpaWrmContext = async ()=>{
    return (0, $hgi0g.default)($027e7c56f31b7541$var$SPA_WRM_CONTEXT_ENDPOINT);
};
const $027e7c56f31b7541$var$createResourceElement = ({ url: url, resourceType: resourceType, key: key, batchType: batchType })=>{
    let element;
    if (resourceType === 'JAVASCRIPT') {
        element = globalThis.document?.createElement('script');
        element.setAttribute('crossorigin', '');
        element.setAttribute('src', url);
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    } else {
        element = globalThis.document?.createElement('link');
        element.setAttribute('crossorigin', '');
        element.setAttribute('href', url);
        element.setAttribute('rel', 'stylesheet');
        element.setAttribute('media', 'all');
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    }
    return element;
};
let $027e7c56f31b7541$var$hasWrmInitialised;
const $027e7c56f31b7541$var$runBootstrap = ()=>{
    const spaWrmContext = $027e7c56f31b7541$var$fetchSpaWrmContext();
    return new Promise((resolve, reject)=>{
        spaWrmContext.then(({ data: data, errors: errors, resources: resources })=>{
            // eslint-disable-next-line no-multi-assign
            const WRM = globalThis.WRM = globalThis.WRM || {};
            WRM._unparsedData = data;
            WRM._unparsedErrors = errors;
            if (WRM._dataArrived) WRM._dataArrived();
            resources.map($027e7c56f31b7541$var$createResourceElement).forEach((element)=>globalThis.document?.head.appendChild(element));
            resolve();
        }).catch((error)=>{
            (0, $9pTd3.fireErrorAnalytics)({
                error: new Error((0, $e5Kmg.safeStringify)(error)),
                meta: {
                    id: 'bootstrap-wrm-client',
                    packageName: 'common-bridge',
                    teamName: 'jfp-magma'
                }
            });
            reject(new Error('Failed to fetch the spa wrm context'));
        });
    });
};
const $027e7c56f31b7541$export$d001f71dd306cb0c = ()=>{
    if (false) return Promise.resolve();
    if ($027e7c56f31b7541$var$hasWrmInitialised) return $027e7c56f31b7541$var$hasWrmInitialised;
    // todo maybe a more robust check to validate whether WRM initialisation already underway?
    if (typeof globalThis.WRM !== 'undefined') $027e7c56f31b7541$var$hasWrmInitialised = Promise.resolve();
    else $027e7c56f31b7541$var$hasWrmInitialised = $027e7c56f31b7541$var$runBootstrap();
    return $027e7c56f31b7541$var$hasWrmInitialised;
};

});



parcelRegister("ligZL", function(module, exports) {
$parcel$export(module.exports, "wrmRequire", () => $cfd4a2a9e13f6c24$export$cc9d8f51375ef66a);

var $7rBE0 = parcelRequire("7rBE0");

var $ej5JA = parcelRequire("ej5JA");
const $cfd4a2a9e13f6c24$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR))=>(0, $7rBE0.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError
    });

});

parcelRegister("jb3ni", function(module, exports) {
$parcel$export(module.exports, "wrmRequireWithPrefetch", () => $4b0178a6bf26b876$export$e53a5db19a39ed2f);

var $7rBE0 = parcelRequire("7rBE0");

var $ej5JA = parcelRequire("ej5JA");
const $4b0178a6bf26b876$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR))=>(0, $7rBE0.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError,
        batchUrl: batchUrl
    });

});


parcelRegister("kxCpN", function(module, exports) {
$parcel$export(module.exports, "sendStartMarkForLegacyIssueCreate", () => $4bd568bdda78fab3$export$7dbcbf47a4e0e00f);
$parcel$export(module.exports, "sendEndMarkForLegacyIssueCreate", () => $4bd568bdda78fab3$export$b5c5d408bb7fd104);

var $2QTvK = parcelRequire("2QTvK");

var $cKx4P = parcelRequire("cKx4P");
const $4bd568bdda78fab3$export$7dbcbf47a4e0e00f = ({ isInitialLoad: isInitialLoad, triggerSource: triggerSource })=>{
    if (typeof isInitialLoad === 'boolean' && triggerSource !== undefined) {
        if (isInitialLoad) (0, $cKx4P.legacyIssueCreateInitialRenderInteraction).start();
        else (0, $cKx4P.legacyIssueCreateTransitionInteraction).start();
        (0, $cKx4P.legacyIssueCreateCombinedInteraction).start();
    }
};
const $4bd568bdda78fab3$export$b5c5d408bb7fd104 = async ({ isInitialLoad: isInitialLoad, triggerSource: triggerSource })=>{
    const Events = await (0, $2QTvK.apiReady)();
    const onCreateIssueDialogRendered = ()=>{
        if (typeof isInitialLoad === 'boolean') {
            if (isInitialLoad) (0, $cKx4P.legacyIssueCreateInitialRenderInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
            else (0, $cKx4P.legacyIssueCreateTransitionInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
            (0, $cKx4P.legacyIssueCreateCombinedInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
        }
        Events.unbind('createIssueDialogRendered', onCreateIssueDialogRendered);
    };
    Events.bind('createIssueDialogRendered', onCreateIssueDialogRendered);
};

});
parcelRegister("2QTvK", function(module, exports) {
$parcel$export(module.exports, "apiReady", () => $8b17da24b9e1b1f2$export$330fb1a04c974aad);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $gjeS9 = parcelRequire("gjeS9");
let $8b17da24b9e1b1f2$var$currentBridge;
const $8b17da24b9e1b1f2$export$330fb1a04c974aad = async ()=>{
    if ($8b17da24b9e1b1f2$var$currentBridge) return $8b17da24b9e1b1f2$var$currentBridge;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/wrm/no-load-bridge
    const Events = await (0, $gjeS9.loadBridge)({
        name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    });
    $8b17da24b9e1b1f2$var$currentBridge = Events;
    return Events;
};

});

parcelRegister("cKx4P", function(module, exports) {
$parcel$export(module.exports, "legacyIssueCreateInitialRenderInteraction", () => $b0beec06c3c56c69$export$2bc24132dfd54487);
$parcel$export(module.exports, "legacyIssueCreateTransitionInteraction", () => $b0beec06c3c56c69$export$ba0054dee3105c90);
$parcel$export(module.exports, "legacyIssueCreateCombinedInteraction", () => $b0beec06c3c56c69$export$52353a8848646ccd);

var $hqYEY = parcelRequire("hqYEY");
const $b0beec06c3c56c69$export$2bc24132dfd54487 = (0, $hqYEY.metrics).interaction({
    key: 'legacy-issue-create.initial-render'
});
const $b0beec06c3c56c69$export$ba0054dee3105c90 = (0, $hqYEY.metrics).interaction({
    key: 'legacy-issue-create.transition'
});
const $b0beec06c3c56c69$export$52353a8848646ccd = (0, $hqYEY.metrics).interaction({
    key: 'legacy-issue-create.combined'
});

});



const $8b9f565bf0bbac99$export$d983e94cf86f65d = 'global-create-button';
const $8b9f565bf0bbac99$export$7e22286cafe320a7 = 'keyboard-shortcut';

parcelRegister("hu0Oo", function(module, exports) {
$parcel$export(module.exports, "useInitializePersistentIssueCreateModalView", () => $ddec5dddf62df382$export$9086117e14a55509);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $fYeTG = parcelRequire("fYeTG");

var $jipjz = parcelRequire("jipjz");

var $2aY2d = parcelRequire("2aY2d");

var $80UiT = parcelRequire("80UiT");
const $ddec5dddf62df382$export$9086117e14a55509 = ()=>{
    const [{ shouldShowMiniModalSpotlight: shouldShowMiniModalSpotlight }, { setShouldPushMiniModalDiscoverability: setShouldPushMiniModalDiscoverability, setPersistentModalView: setPersistentModalView }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const { data: projectContext } = (0, $2aY2d.useProjectContext)();
    const hasUserSeenMiniModal = (0, $eJOHy.useRef)(false);
    const isJSM = projectContext?.projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT);
    const { data: resource } = (0, $80UiT.usePersistentIssueCreateModalViewResource)();
    const isMobileExperienceEnabled = (0, $fYeTG.isMobileAndInMvpOrExistingUsersExperiment)();
    /**
	 * It only handles the initialization part as after the modal is opened the persistentModalView
	 * would be handled by the `actions` of `useTriggerIssueCreateModal`.
	 */ (0, $eJOHy.useEffect)(()=>{
        setPersistentModalView(resource?.view || 'modal');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
	 * JSM has opted out so we update the `shouldPushMiniModalDiscoverability` on every project change
	 * until the discoverability push has been done, meaning that the user has seen the mini modal being
	 * shown as the default modal.
	 *
	 * Mobile is also opting out of having any mini modal discoverability and not interacting with any of the discoverability state
	 * for if the user returns to desktop.
	 *
	 * If the user has seen the mini modal from discoverability push (hasUserSeenMiniModal) or
	 * dismiss its nudge (isDiscoPushComplete), shouldPushMiniModalDiscoverability should never be true again.
	 */ (0, $eJOHy.useEffect)(()=>{
        if (resource?.isDiscoPushComplete || hasUserSeenMiniModal.current) setShouldPushMiniModalDiscoverability(false);
        else setShouldPushMiniModalDiscoverability(!isJSM && !isMobileExperienceEnabled);
    }, [
        resource?.isDiscoPushComplete,
        setShouldPushMiniModalDiscoverability,
        isJSM,
        isMobileExperienceEnabled
    ]);
    /**
	 * `shouldShowMiniModalSpotlight` can be used to determine if user has seen the mini modal
	 * as it is only set `onModalOpen`, which means, if it is true, the modal is opened with mini view
	 * and the user will see it.
	 */ (0, $eJOHy.useEffect)(()=>{
        if (shouldShowMiniModalSpotlight && !hasUserSeenMiniModal.current) hasUserSeenMiniModal.current = true;
    }, [
        shouldShowMiniModalSpotlight
    ]);
    return null;
};

});
parcelRegister("jipjz", function(module, exports) {
$parcel$export(module.exports, "useTriggerIssueCreateModal", () => $fd6d975a09a2a8e6$export$71e0eb7b8a91a156);
$parcel$export(module.exports, "useOpenIssueCreateModal", () => $fd6d975a09a2a8e6$export$47cf258b1046080b);
$parcel$export(module.exports, "withNewGICProvider", () => $fd6d975a09a2a8e6$export$558a195c5bfe3787);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $iIqFO = parcelRequire("iIqFO");

var $3UrQk = parcelRequire("3UrQk");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $dRfS0 = parcelRequire("dRfS0");

var $eJrcF = parcelRequire("eJrcF");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");

var $4cTDP = parcelRequire("4cTDP");

var $84DOT = parcelRequire("84DOT");

var $bitlK = parcelRequire("bitlK");

var $hBHUL = parcelRequire("hBHUL");
const $fd6d975a09a2a8e6$export$d4c72bab9d6cc13a = {
    inProgressIssueID: undefined,
    isModalOpen: false,
    isSubsequentLoad: false,
    // isSubTaskCreationOpen is used for creating subtasks with new GIC
    isSubTaskCreationOpen: false,
    // isCreateLinkedIssue is used for creating linked issues with new GIC
    isCreateLinkedIssue: false,
    wasStateRestored: false,
    // payload can be used to control the initial values displayed in the GIC Modal
    payload: null,
    // id for the GIC Modal component
    id: 'create-issue-dialog',
    // title for the GIC modal
    title: null,
    // sectionMessage is used to show an info banner at the top of the GIC modal
    sectionMessage: null,
    // submitErrorMessage is used to show an error banner at the top of the GIC modal
    submitErrorMessage: undefined,
    // globalEventNamespaces is the list of event namespaces to which data of created issues will be published
    globalEventNamespaces: [
        (0, $3UrQk.GLOBAL_EVENT_NAMESPACE)
    ],
    // fieldsToAddInPublishedData: list of additioanl fields that should be appended in the data published for
    // created issues. By default we publish summary, status, assignee, duedate, project, issuetype & priority
    fieldsToAddInPublishedData: [],
    // Used on Create Incident from Alerts functionality. Only relevant for Opsgenie alert pages
    alertsToBeLinked: undefined,
    // if onIssueCreate is passed for every issue created in the session onIssueCreate is called with
    // the data of each issue created
    onIssueCreate: null,
    onClose: null,
    // onSiteSelection is called when a site is selected in the site picker
    onSiteSelection: null,
    // onProjectSelection is called when a project is selected in the project picker
    onProjectSelection: null,
    // only show required fields
    displayOnlyRequiredFields: false,
    // disables the success flag
    disableCreationSuccessFlag: false,
    // toggle the 'create another issue' checkbox
    displayCreateAnotherIssueToggle: true,
    // toggle display of site picker field.
    displaySitePicker: false,
    // do not allow user to change issue project
    disableProjectDropdown: false,
    // do not allow user to change issue type
    disableIssueTypeDropdown: false,
    // triggerPoinKey can be used to identify specific trigger point of new GIC
    triggerPointKey: (0, $84DOT.TRIGGER_POINT_KEY_NOT_DEFINED),
    // context can be used to pass data like rank/board data which will be used as payload for issue creation
    context: undefined,
    // the view state for the minimizable modal
    minimizableModalView: 'modal',
    // the modal view maybe persistent depending on conditions, if this value is present, it may override the `minimizableModalView` during `openIssueCreateModal`.
    persistentModalView: undefined,
    // whether we should display mini modal by default for the first time. If this is true, it will override the view state to `mini` during `openIssueCreateModal`.
    shouldPushMiniModalDiscoverability: undefined,
    // whether we should display mini modal spotlight for the first time.
    shouldShowMiniModalSpotlight: undefined,
    // modal was attempted to be opened when already opened
    wasModalRetriggered: false,
    // if there is an existing gic open - we only apply the next state if they discard their current issue
    openIssueCreateModalNextState: {},
    // when an issue is discarded we will reinitialise the gic modal
    shouldInitFetchConfig: false,
    interactedWithModalChangerButtons: false,
    // open modal for the jql board trigger point
    isModalLoadInContext: false,
    // opt-out of the minimizable GIC modal
    disableMinimizableModal: false,
    // switch to control the hide and display of minimizable buttons
    displayMinimizableButtons: true,
    // switch to control the hide and display of header action container
    displayHeaderActionContainer: true,
    // do not override "use request type fields" toggle state
    overrideUseRequestTypeFieldsToggleState: undefined,
    /**
	 * this is for applying the container styles on the GIC containers except modal view
	 */ containerStyle: {},
    // this flag is for enable the minidesign for a trigger point without being in mini view
    isMiniDesignEnabled: false,
    // this flag is for the GIC multiple layout experiment by Makkuro
    isEnrolledAndTargetedForGicMultipleLayouts: false,
    // optional sessionId used for the current issue creation session
    sessionId: undefined,
    // optional component - when supplied, this wraps every field as children within the GIC modal
    FieldWrapperComponent: undefined,
    // optional component - Renders external component above form fields
    ExternalControls: undefined,
    // optional ID of the jql swimlane we are creating issues in
    jqlSwimlaneId: undefined,
    // prefilled custom Fields if any
    prefilledCustomFields: {},
    // callback for ecosystem API to execute
    ecosystemCallback: undefined,
    // product where issue create anywhere modal is used
    product: undefined,
    // what's the consumer of the issue create anywhere modal in a product
    actionSource: undefined,
    // Field IDs that will remain visible even when the smart fields feature recommends them to be hidden.
    optOutSmartFieldIds: undefined,
    // refrence of the button from where GIC modal is triggered
    triggerButtonRef: null,
    // reference to the element to focus when the modal is closed
    returnFocusRef: undefined
};
const $fd6d975a09a2a8e6$export$e324594224ef24da = {
    restoreState: (stateToRestore)=>({ setState: setState, getState: getState })=>{
            const { isSubsequentLoad: isSubsequentLoad, isModalOpen: isModalOpen } = getState();
            if (!isModalOpen && stateToRestore.isModalOpen) (0, $hBHUL.startGlobalIssueCreateMetrics)(isSubsequentLoad);
            setState(stateToRestore);
        },
    openIssueCreateModal: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isModalOpen) /* If there is an existing gic open then we will defer the state change to prevent
                       clashing with the issue in creation. */ setState({
                wasModalRetriggered: true,
                openIssueCreateModalNextState: nextState
            });
            else {
                (0, $hBHUL.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                const isDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $hBHUL.isPartOfDiscoverabilityTriggers)(nextState?.triggerPointKey);
                const nextModalView = isDiscoverabilityPushEnabled ? (0, $hBHUL.getNextModalView)(isDiscoPushTriggerPoint, currentState.persistentModalView, $fd6d975a09a2a8e6$export$d4c72bab9d6cc13a.minimizableModalView) : 'modal';
                if ((0, $4cTDP.fg)('fix-gryf-a11y-issues')) {
                    /*
					 * This is done to always focus the Issue Create Modal trigger button whenever it's clicked
					 * so that we can store the reference of this
					 * and use that to re-focus the button whenever the modal is closed
					 */ let triggerButton;
                    const handleButtonClick = (event)=>{
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        const triggerButtonTarget = event.target;
                        triggerButton = triggerButtonTarget?.closest('button');
                        triggerButton?.focus();
                    };
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    document.addEventListener('click', handleButtonClick);
                    setTimeout(()=>{
                        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                        document.removeEventListener('click', handleButtonClick);
                    }, 0);
                    setTimeout(()=>{
                        setState({
                            ...$fd6d975a09a2a8e6$export$d4c72bab9d6cc13a,
                            ...isDiscoverabilityPushEnabled && {
                                minimizableModalView: nextModalView,
                                persistentModalView: currentState.persistentModalView,
                                ...(0, $hBHUL.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                            },
                            inProgressIssueID: (0, $aXKmr.v4)(),
                            isSubsequentLoad: currentState.isSubsequentLoad,
                            isModalOpen: true,
                            wasModalRetriggered: currentState.isModalOpen,
                            ...(0, $4cTDP.fg)('quick_actions_with_hotkeys_ga') ? {
                                triggeredViaHotKey: !!nextState?.triggeredViaHotKey
                            } : {},
                            ...nextState,
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
                            triggerButtonRef: triggerButton || document.activeElement
                        });
                    }, 0);
                } else setState({
                    ...$fd6d975a09a2a8e6$export$d4c72bab9d6cc13a,
                    ...isDiscoverabilityPushEnabled && {
                        minimizableModalView: nextModalView,
                        persistentModalView: currentState.persistentModalView,
                        ...(0, $hBHUL.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                    },
                    inProgressIssueID: (0, $aXKmr.v4)(),
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: currentState.isModalOpen,
                    ...(0, $4cTDP.fg)('quick_actions_with_hotkeys_ga') ? {
                        triggeredViaHotKey: !!nextState?.triggeredViaHotKey
                    } : {},
                    ...nextState
                });
            }
        },
    closeIssueCreateModal: (hasIssueCreated)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
            const isValidDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $hBHUL.isPartOfDiscoverabilityTriggers)(currentState.triggerPointKey);
            const shouldUpdatePersistentModalView = isDiscoverabilityPushEnabled && hasIssueCreated && isValidDiscoPushTriggerPoint;
            const shouldPersistDiscoverabilityState = isDiscoverabilityPushEnabled && currentState.shouldPushMiniModalDiscoverability && !isValidDiscoPushTriggerPoint;
            setState({
                ...$fd6d975a09a2a8e6$export$d4c72bab9d6cc13a,
                callbackPayload: undefined,
                ...shouldPersistDiscoverabilityState && {
                    shouldPushMiniModalDiscoverability: true
                },
                ...isDiscoverabilityPushEnabled && {
                    persistentModalView: currentState.persistentModalView
                },
                ...shouldUpdatePersistentModalView && {
                    persistentModalView: currentState.minimizableModalView === 'mini' ? 'mini' : 'modal'
                },
                isModalOpen: false,
                isSubsequentLoad: true
            });
            (0, $iIqFO.CreateIssueUFOExperience).abort({
                metadata: {
                    wasStateRestored: getState().wasStateRestored
                }
            });
        },
    clearSectionMessage: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                sectionMessage: null
            });
        },
    setDisplayOnlyRequiredFields: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                displayOnlyRequiredFields: nextState
            });
        },
    setMinimizableModalView: (minimizableModalView)=>({ setState: setState })=>{
            setState({
                minimizableModalView: minimizableModalView,
                interactedWithModalChangerButtons: true
            });
        },
    resetWasModalRetriggered: (applyNextState = false)=>({ setState: setState, getState: getState })=>{
            if (applyNextState) {
                const currentState = getState();
                (0, $hBHUL.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...$fd6d975a09a2a8e6$export$d4c72bab9d6cc13a,
                    ...!currentState.isEnrolledAndTargetedForGicMultipleLayouts && {
                        persistentModalView: currentState.persistentModalView
                    },
                    inProgressIssueID: currentState.inProgressIssueID,
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: false,
                    minimizableModalView: 'modal',
                    openIssueCreateModalNextState: {},
                    shouldInitFetchConfig: true,
                    ...currentState.openIssueCreateModalNextState
                });
            } else setState({
                minimizableModalView: 'modal',
                wasModalRetriggered: false,
                openIssueCreateModalNextState: {}
            });
        },
    resetShouldInitFetchConfig: ()=>({ setState: setState })=>{
            setState({
                shouldInitFetchConfig: false
            });
        },
    setCallbackPayload: (callbackPayload)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                callbackPayload: {
                    id: currentState.callbackPayload?.id ?? '',
                    data: callbackPayload
                }
            });
        },
    setShouldPushMiniModalDiscoverability: (shouldPushMiniModalDiscoverability)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability
            });
        },
    dismissModalSpotlight: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldShowMiniModalSpotlight: false
            });
        },
    setPersistentModalView: (persistentModalView)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                persistentModalView: persistentModalView
            });
        },
    removeAlertFromAlertsToBeLinked: (alertId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const alertsToBeLinked = currentState.alertsToBeLinked?.filter((entry)=>entry !== alertId);
            setState({
                alertsToBeLinked: alertsToBeLinked
            });
        },
    setSessionId: (sessionId)=>({ setState: setState })=>{
            setState({
                sessionId: sessionId
            });
        }
};
const $fd6d975a09a2a8e6$var$store = (0, $GtRbT.createStore)({
    name: 'issue-create.issue-create-form.use-trigger-issue-create-modal',
    initialState: $fd6d975a09a2a8e6$export$d4c72bab9d6cc13a,
    actions: $fd6d975a09a2a8e6$export$e324594224ef24da
});
const $fd6d975a09a2a8e6$var$useTriggerIssueCreateModalState = (0, $iJq0l.createStateHook)($fd6d975a09a2a8e6$var$store);
const $fd6d975a09a2a8e6$var$useTriggerIssueCreateModalActions = (0, $iJq0l.createActionsHook)($fd6d975a09a2a8e6$var$store);
const $fd6d975a09a2a8e6$export$71e0eb7b8a91a156 = ()=>{
    const createState = $fd6d975a09a2a8e6$var$useTriggerIssueCreateModalState();
    const createActions = $fd6d975a09a2a8e6$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { openIssueCreateModal: openIssueCreateModal, ...otherActions } = createActions;
    const openIssueCreateModalWithAnalytics = (0, $eJOHy.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey,
            ...nextState?.addChildWorkItemTriggerSource ? {
                addChildWorkItemTriggerSource: nextState?.addChildWorkItemTriggerSource
            } : {},
            ...nextState?.product ? {
                product: nextState.product
            } : {},
            ...nextState?.actionSource ? {
                actionSource: nextState.actionSource
            } : {}
        };
        (0, $kRgKj.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
    return [
        createState,
        {
            ...otherActions,
            openIssueCreateModal: openIssueCreateModalWithAnalytics
        }
    ];
};
const $fd6d975a09a2a8e6$export$47cf258b1046080b = ()=>{
    const { openIssueCreateModal: openIssueCreateModal } = $fd6d975a09a2a8e6$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [, { setSitePickerState: setSitePickerState }] = (0, $bitlK.useSitePickerContext)();
    return (0, $eJOHy.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey,
            ...nextState?.product ? {
                product: nextState.product
            } : {},
            ...nextState?.actionSource ? {
                actionSource: nextState.actionSource
            } : {},
            ...nextState?.addChildWorkItemTriggerSource ? {
                addChildWorkItemTriggerSource: nextState?.addChildWorkItemTriggerSource
            } : {}
        };
        (0, $kRgKj.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        // overrideCloudId only used for embedded GIC
        if (nextState?.payload?.overrideCloudId) // set cloudId inside the state if there's an override
        setSitePickerState({
            selectedCloudId: nextState?.payload?.overrideCloudId
        });
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal,
        setSitePickerState
    ]);
};
const $fd6d975a09a2a8e6$export$4c674fe824b8f278 = (0, $ht3nQ.createSubscriber)($fd6d975a09a2a8e6$var$store);
function $fd6d975a09a2a8e6$export$558a195c5bfe3787(WrappedComponent) {
    return (props)=>{
        const [, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = $fd6d975a09a2a8e6$export$71e0eb7b8a91a156();
        const { data: data } = (0, $eJrcF.useResource)((0, $dRfS0.gicOptInStatusResources));
        const currentIssueCreateVisibility = data && data?.gicOptInStatus;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
            openIssueCreateModal: openIssueCreateModal,
            closeIssueCreateModal: closeIssueCreateModal,
            currentIssueCreateVisibility: (0, $4cTDP.fg)('gic-user-pref-true') ? true : currentIssueCreateVisibility?.isEnabled || false,
            ...props
        });
    };
}

});
parcelRegister("iIqFO", function(module, exports) {
$parcel$export(module.exports, "CreateIssueUFOExperience", () => $e524612cc2a761dc$export$cd75c112ac11a83b);
$parcel$export(module.exports, "EditIssueTypeUFOExperience", () => $e524612cc2a761dc$export$7d25d25bed94d6e2);
$parcel$export(module.exports, "CreateIssueTypeUFOExperience", () => $e524612cc2a761dc$export$fda88e8e14acb615);
$parcel$export(module.exports, "StatusFieldLoad", () => $e524612cc2a761dc$export$e890e797a25e655c);
$parcel$export(module.exports, "GlobalIssueCreateModalSubmitUFOExperience", () => $e524612cc2a761dc$export$70208657c8d471a7);
$parcel$export(module.exports, "EcosystemAPIPrefillingUFOExperience", () => $e524612cc2a761dc$export$b2d8f8edec75f571);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");
const $e524612cc2a761dc$export$cd75c112ac11a83b = new (0, $f39LL.UFOExperience)('global-issue-create.create-issue', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom,
    category: 'global-issue-create.create-issue'
});
const $e524612cc2a761dc$export$7d25d25bed94d6e2 = new (0, $f39LL.UFOExperience)('global-issue-create.create-issue.issue-type-field.edit-issue-type', {
    type: (0, $2lxLk.ExperienceTypes).Operation,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom
});
const $e524612cc2a761dc$export$fda88e8e14acb615 = new (0, $f39LL.UFOExperience)('global-issue-create.create-issue.issue-type-field.create-issue-type', {
    type: (0, $2lxLk.ExperienceTypes).Operation,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom
});
const $e524612cc2a761dc$export$e890e797a25e655c = new (0, $f39LL.UFOExperience)('global-issue-create.create-issue.status-field', {
    type: (0, $2lxLk.ExperienceTypes).Load,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
});
const $e524612cc2a761dc$export$70208657c8d471a7 = new (0, $f39LL.UFOExperience)('modern-global-issue-create.modal.issue-submit', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad,
    category: 'modern-global-issue-create.modal.issue-submit'
});
const $e524612cc2a761dc$export$b2d8f8edec75f571 = new (0, $f39LL.UFOExperience)('ecosystem-api-new-gic-prefilling', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom,
    category: 'ecosystem-api-new-gic-prefilling'
});

});

parcelRegister("3UrQk", function(module, exports) {
$parcel$export(module.exports, "REQUIRED", () => $7fffaa4718e25dbf$export$b1c05b34d317c074);
$parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", () => $7fffaa4718e25dbf$export$1a020bd73f33e5a);
$parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", () => $7fffaa4718e25dbf$export$9eadc594a5383580);
$parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", () => $7fffaa4718e25dbf$export$a1a7caa1e4a73c9f);
$parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", () => $7fffaa4718e25dbf$export$cf70f9220e6a2f50);
$parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", () => $7fffaa4718e25dbf$export$aac4661200ba4104);
$parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", () => $7fffaa4718e25dbf$export$a23c32d5cf54cba0);
$parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", () => $7fffaa4718e25dbf$export$74ab3898ae683660);
$parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", () => $7fffaa4718e25dbf$export$983715bb9b0f9b2c);
$parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", () => $7fffaa4718e25dbf$export$40f6793dd75f4e52);
$parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", () => $7fffaa4718e25dbf$export$3bf5bce483cc2c30);
$parcel$export(module.exports, "ISSUE_CREATE_TYPE", () => $7fffaa4718e25dbf$export$30cc1fd33e7c7258);
$parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", () => $7fffaa4718e25dbf$export$8170252f0ea43511);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

const $7fffaa4718e25dbf$export$17bcab948893a9ba = 'worklog';
const $7fffaa4718e25dbf$export$b1c05b34d317c074 = 'REQUIRED';
const $7fffaa4718e25dbf$export$f10b32dfda12e96e = 'unknown';
const $7fffaa4718e25dbf$export$e5e4b8c32e68dd0b = 'networkError';
const $7fffaa4718e25dbf$export$2d06efb8146cd043 = 'graphQLError';
const $7fffaa4718e25dbf$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
const $7fffaa4718e25dbf$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
const $7fffaa4718e25dbf$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
const $7fffaa4718e25dbf$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
const $7fffaa4718e25dbf$export$aac4661200ba4104 = 'worklog_startDate';
const $7fffaa4718e25dbf$export$a23c32d5cf54cba0 = 'worklog_description';
const $7fffaa4718e25dbf$export$74ab3898ae683660 = [
    'worklog_adjustmentAmount',
    'worklog_adjustEstimate',
    'worklog_activate'
];
const $7fffaa4718e25dbf$export$63fd567c1d0aca19 = [
    ...$7fffaa4718e25dbf$export$74ab3898ae683660,
    $7fffaa4718e25dbf$export$a1a7caa1e4a73c9f,
    $7fffaa4718e25dbf$export$cf70f9220e6a2f50,
    $7fffaa4718e25dbf$export$aac4661200ba4104,
    $7fffaa4718e25dbf$export$a23c32d5cf54cba0
];
const $7fffaa4718e25dbf$export$983715bb9b0f9b2c = {
    [$7fffaa4718e25dbf$export$17bcab948893a9ba]: $7fffaa4718e25dbf$export$63fd567c1d0aca19
};
const $7fffaa4718e25dbf$export$40f6793dd75f4e52 = {
    behavior: 'auto',
    scrollMode: 'if-needed',
    block: 'start'
};
const $7fffaa4718e25dbf$export$3bf5bce483cc2c30 = [
    'com.atlassian.servicedesk:sd-request-participants'
];
const $7fffaa4718e25dbf$export$30cc1fd33e7c7258 = {
    linkedIssue: 'LINKED_ISSUE_CREATE',
    standard: 'STANDARD'
};
const $7fffaa4718e25dbf$export$8170252f0ea43511 = 'QuickCreateIssue';

});

parcelRegister("84DOT", function(module, exports) {
$parcel$export(module.exports, "GENERIC_FORGE_USE_PRODUCT_MODALS", () => $0cf751b242c962b3$export$a05673a22505d5ee);
$parcel$export(module.exports, "GENERIC_GLOBAL_CREATE_BUTTON", () => $0cf751b242c962b3$export$c78d329777576aa0);
$parcel$export(module.exports, "MOBILE_GLOBAL_CREATE_BUTTON", () => $0cf751b242c962b3$export$992ab052fd10f8e8);
$parcel$export(module.exports, "GENERIC_KEYBOARD_SHORTCUT", () => $0cf751b242c962b3$export$affdc3af7a9a4677);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC", () => $0cf751b242c962b3$export$7e9cfd1f59e60910);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_SUBTASK", () => $0cf751b242c962b3$export$708499dcd016e5e9);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_CHILD_ISSUE", () => $0cf751b242c962b3$export$e1c8789144c4c810);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_SUBTASK", () => $0cf751b242c962b3$export$c5afabb7a17e802);
$parcel$export(module.exports, "JSW_RELEASES_CREATE_ISSUE", () => $0cf751b242c962b3$export$2086a63173b79b56);
$parcel$export(module.exports, "JSW_ROADMAP_CREATE_ISSUE", () => $0cf751b242c962b3$export$fe1e5e4597147709);
$parcel$export(module.exports, "JSW_SECURITY_CREATE_ISSUE", () => $0cf751b242c962b3$export$9bc326812a93707);
$parcel$export(module.exports, "JSM_CALENDAR_CREATE_CHANGE_REQUEST", () => $0cf751b242c962b3$export$f352934e06f44599);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_DETAIL", () => $0cf751b242c962b3$export$6ae07c77acc64360);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_LIST", () => $0cf751b242c962b3$export$b41d0684e4b6ab1);
$parcel$export(module.exports, "JSM_CREATE_PROBLEM_FROM_INCIDENT_AI", () => $0cf751b242c962b3$export$1110454816343634);
$parcel$export(module.exports, "JSM_EMPTY_QUEUE_CREATE_REQUEST", () => $0cf751b242c962b3$export$be9b2b1329ff7ec9);
$parcel$export(module.exports, "JSM_PROJECT_SUMMARY_CREATE_REQUEST", () => $0cf751b242c962b3$export$bc365eb0775af583);
$parcel$export(module.exports, "JSW_CREATE_ISSUE_DIALOG", () => $0cf751b242c962b3$export$aa348159181703a0);
$parcel$export(module.exports, "ISSUE_VIEW_CREATE_LINKED_ISSUE", () => $0cf751b242c962b3$export$f90eec3841adf619);
$parcel$export(module.exports, "COMMAND_PALETTE_CREATE_LINKED_ISSUE", () => $0cf751b242c962b3$export$718822a309bffada);
$parcel$export(module.exports, "SERVICE_DESK_LINKED_ISSUE_TRIGEER", () => $0cf751b242c962b3$export$2753dafac81e805c);
$parcel$export(module.exports, "JSW_INCIDENTS_CREATE_JSM_PIR_TRIGGER", () => $0cf751b242c962b3$export$7c4d5cc5711d9294);
$parcel$export(module.exports, "JPO_DIALOGS_CREATE_ISSUE_TRIGGER", () => $0cf751b242c962b3$export$998dfc72404b9e14);
$parcel$export(module.exports, "JSW_ADAPTED_GLOBAL_ISSUE_CREATE", () => $0cf751b242c962b3$export$fc180a4b5785d2f4);
$parcel$export(module.exports, "JSW_CREATE_EPIC_ISSUE", () => $0cf751b242c962b3$export$946ec0b21cb84fd0);
$parcel$export(module.exports, "CREATE_ISSUE_ACTIVE_SPRINT_EMPTY_VIEW", () => $0cf751b242c962b3$export$5b97e2844e620e54);
$parcel$export(module.exports, "CREATE_SUBTASK_NIN_TRIGGER", () => $0cf751b242c962b3$export$b99842c2cf46f6be);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_NOT_DEFINED", () => $0cf751b242c962b3$export$8d987f6e80b74000);
$parcel$export(module.exports, "ISSUE_PARENT_SWITCHER_FIELD_CREATE_ISSUE", () => $0cf751b242c962b3$export$8de9fa43731c4b5b);
$parcel$export(module.exports, "POLARIS_CREATE_DELIVERY_ISSUE", () => $0cf751b242c962b3$export$87249ccbfd10fb78);
$parcel$export(module.exports, "HOME_PAGE_DEFAULT_OPEN_GIC", () => $0cf751b242c962b3$export$c0eeeb31d264de76);
$parcel$export(module.exports, "ISSUE_CREATE_EMBEDDABLE_TRIGGER", () => $0cf751b242c962b3$export$f546e18e46478c84);
$parcel$export(module.exports, "DEVELOPER_ESCALATIONS_ISSUE_CREATE_TRIGGER", () => $0cf751b242c962b3$export$1784e634ba79f1f9);
$parcel$export(module.exports, "JWM_INLINE_CREATE", () => $0cf751b242c962b3$export$145eb8935a34e85e);
$parcel$export(module.exports, "POLARIS_GLOBAL_SUBMIT_IDEA_SWITCH_PROJECTS_TRIGGER", () => $0cf751b242c962b3$export$32648b574a536c8b);
$parcel$export(module.exports, "JIRA_ISSUE_COMMENT", () => $0cf751b242c962b3$export$220cd7b39e0b57a);
$parcel$export(module.exports, "JIRA_INBOX_CREATE_WORK_ITEM", () => $0cf751b242c962b3$export$ab926dced0f69c1e);
$parcel$export(module.exports, "UC_ATLASSIAN_HOME_CREATE_ISSUE", () => $0cf751b242c962b3$export$d3df6a0ce4e0bc8b);
$parcel$export(module.exports, "JIRA_ISSUE_TABLE_TRIGGER", () => $0cf751b242c962b3$export$99b5cdc74c6071b4);
$parcel$export(module.exports, "ALLOWED_EXTERNAL_CONTROLS", () => $0cf751b242c962b3$export$c0e2ab74dfaa67cc);
$parcel$export(module.exports, "LIST_OF_CHILD_ISSUES_TRIGGER_POINTS", () => $0cf751b242c962b3$export$7a8328e1f8bd992b);
const $0cf751b242c962b3$export$a05673a22505d5ee = 'forge-open-issue-create';
const $0cf751b242c962b3$export$c78d329777576aa0 = 'global-create-button';
const $0cf751b242c962b3$export$992ab052fd10f8e8 = 'mobile-global-create-button';
const $0cf751b242c962b3$export$affdc3af7a9a4677 = 'keyboard-shortcut';
const $0cf751b242c962b3$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
const $0cf751b242c962b3$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
const $0cf751b242c962b3$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
const $0cf751b242c962b3$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
const $0cf751b242c962b3$export$2086a63173b79b56 = 'jsw-releases-create-issue';
const $0cf751b242c962b3$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
const $0cf751b242c962b3$export$9bc326812a93707 = 'jsw-security-create-issue';
const $0cf751b242c962b3$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
const $0cf751b242c962b3$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
const $0cf751b242c962b3$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
const $0cf751b242c962b3$export$1110454816343634 = 'jsm-create-problem-from-incident-ai';
const $0cf751b242c962b3$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
const $0cf751b242c962b3$export$bc365eb0775af583 = 'jsm-project-summary-create-request';
const $0cf751b242c962b3$export$235b856f54db8916 = 'jwm-board-create-issue';
const $0cf751b242c962b3$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
const $0cf751b242c962b3$export$8e135b62470e5f9a = 'jwm-list-create-issue';
const $0cf751b242c962b3$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
const $0cf751b242c962b3$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
const $0cf751b242c962b3$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
const $0cf751b242c962b3$export$aa348159181703a0 = 'software-create-issue-dialog';
const $0cf751b242c962b3$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
const $0cf751b242c962b3$export$718822a309bffada = 'create-linked-issue-command-palette';
const $0cf751b242c962b3$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
const $0cf751b242c962b3$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
const $0cf751b242c962b3$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
const $0cf751b242c962b3$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
const $0cf751b242c962b3$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
const $0cf751b242c962b3$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
const $0cf751b242c962b3$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
const $0cf751b242c962b3$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
const $0cf751b242c962b3$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
const $0cf751b242c962b3$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
const $0cf751b242c962b3$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
const $0cf751b242c962b3$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
const $0cf751b242c962b3$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
const $0cf751b242c962b3$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
const $0cf751b242c962b3$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
const $0cf751b242c962b3$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $0cf751b242c962b3$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
const $0cf751b242c962b3$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
const $0cf751b242c962b3$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
const $0cf751b242c962b3$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
const $0cf751b242c962b3$export$f546e18e46478c84 = 'issue-create-embed-trigger';
const $0cf751b242c962b3$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
const $0cf751b242c962b3$export$145eb8935a34e85e = 'jwm-inline-create';
const $0cf751b242c962b3$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';
const $0cf751b242c962b3$export$818f24c6c32e18a = 'jira-calendar-create-issue';
const $0cf751b242c962b3$export$220cd7b39e0b57a = 'jira-issue-comment';
const $0cf751b242c962b3$export$ab926dced0f69c1e = 'jira-inbox-create-work-item';
const $0cf751b242c962b3$export$d3df6a0ce4e0bc8b = 'uc-atlassian-home-create-issue';
const $0cf751b242c962b3$export$99b5cdc74c6071b4 = 'jira-issue-table-trigger';
const $0cf751b242c962b3$export$c0e2ab74dfaa67cc = {
    FIELD_IDS: [
        'description'
    ],
    TRIGGER_POINTS: [
        'service-desk-gen-ai-pir'
    ]
};
const $0cf751b242c962b3$export$7a8328e1f8bd992b = [
    $0cf751b242c962b3$export$7e9cfd1f59e60910,
    $0cf751b242c962b3$export$708499dcd016e5e9,
    $0cf751b242c962b3$export$e1c8789144c4c810,
    $0cf751b242c962b3$export$c5afabb7a17e802
];

});

parcelRegister("bitlK", function(module, exports) {
$parcel$export(module.exports, "useSitePickerContext", () => $c532dbef0009ad59$export$f8b5aae013e4cf77);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $c532dbef0009ad59$export$d4c72bab9d6cc13a = {
    selectedCloudId: '',
    siteDomain: ''
};
const $c532dbef0009ad59$export$e324594224ef24da = {
    setSitePickerState: ({ selectedCloudId: selectedCloudId, siteDomain: siteDomain })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                selectedCloudId: selectedCloudId || '',
                siteDomain: siteDomain || ''
            });
        }
};
const $c532dbef0009ad59$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'issue.fields.site-picker',
    initialState: $c532dbef0009ad59$export$d4c72bab9d6cc13a,
    actions: $c532dbef0009ad59$export$e324594224ef24da
});
const $c532dbef0009ad59$export$f8b5aae013e4cf77 = (0, $iJq0l.createHook)($c532dbef0009ad59$export$6f57813fe9f31bf9);

});

parcelRegister("hBHUL", function(module, exports) {
$parcel$export(module.exports, "startGlobalIssueCreateMetrics", () => $ead5ae5f9543822b$export$550b19803bc962ec);
$parcel$export(module.exports, "isPartOfDiscoverabilityTriggers", () => $ead5ae5f9543822b$export$f6bc17a4d9120156);
$parcel$export(module.exports, "discoverabilityPushModalViewOverride", () => $ead5ae5f9543822b$export$8d246e5e04f0b424);
$parcel$export(module.exports, "getNextModalView", () => $ead5ae5f9543822b$export$720579602bb055a2);

var $h6i8k = parcelRequire("h6i8k");

var $iIqFO = parcelRequire("iIqFO");

var $bVObd = parcelRequire("bVObd");

var $Gb6hR = parcelRequire("Gb6hR");
const $ead5ae5f9543822b$export$550b19803bc962ec = (isSubsequentLoad)=>{
    (0, $iIqFO.CreateIssueUFOExperience).start();
    const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, $bVObd.globalIssueCreateModalLoadSubsequent) : (0, $bVObd.globalIssueCreateModalLoad);
    if (isSubsequentLoad) (0, $h6i8k.default)('global-issue.create-modal-subsequent');
    else (0, $h6i8k.default)('global-issue.create-modal');
    globalIssueCreateModalLoadMetric.start();
    (0, $Gb6hR.startGlobalIssueCreateTTIWithAdjustments)();
};
const $ead5ae5f9543822b$export$f6bc17a4d9120156 = (triggerPoint)=>{
    if (!triggerPoint) return false;
    const acceptedTriggerPoints = [
        'global-create-button',
        'keyboard-shortcut'
    ];
    return acceptedTriggerPoints.includes(triggerPoint);
};
const $ead5ae5f9543822b$export$8d246e5e04f0b424 = (shouldPushDiscoverability, isTriggerAccepted, defaultView = 'modal')=>{
    if (!shouldPushDiscoverability) return undefined;
    return {
        minimizableModalView: isTriggerAccepted ? 'mini' : defaultView,
        shouldPushMiniModalDiscoverability: true,
        shouldShowMiniModalSpotlight: isTriggerAccepted
    };
};
const $ead5ae5f9543822b$export$720579602bb055a2 = (isTriggerAccepted, persistentView, defaultView = 'modal')=>{
    if (isTriggerAccepted) return persistentView || defaultView;
    return defaultView;
};

});
parcelRegister("bVObd", function(module, exports) {
$parcel$export(module.exports, "globalIssueCreateModalLoad", () => $4372308d4d36906f$export$5a01a7fa84b239c8);
$parcel$export(module.exports, "globalIssueCreateModalLoadSubsequent", () => $4372308d4d36906f$export$c50ad3c31b6fcfc6);
$parcel$export(module.exports, "successFlagDisplay", () => $4372308d4d36906f$export$4b2382574525bb0f);
$parcel$export(module.exports, "successFlagAddToSprintAction", () => $4372308d4d36906f$export$7839bdaa2f6a2385);
$parcel$export(module.exports, "successFlagClearFiltersAction", () => $4372308d4d36906f$export$c1592e4d8d98963e);

var $hqYEY = parcelRequire("hqYEY");
const $4372308d4d36906f$export$5a01a7fa84b239c8 = (0, $hqYEY.metrics).interaction({
    key: 'global-issue-create-modal'
});
const $4372308d4d36906f$export$c50ad3c31b6fcfc6 = (0, $hqYEY.metrics).interaction({
    key: 'global-issue-create-modal-subsequent'
});
const $4372308d4d36906f$export$4b2382574525bb0f = (0, $hqYEY.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-display'
});
const $4372308d4d36906f$export$7839bdaa2f6a2385 = (0, $hqYEY.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action'
});
const $4372308d4d36906f$export$c1592e4d8d98963e = (0, $hqYEY.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-clear-filters-action'
});

});

parcelRegister("Gb6hR", function(module, exports) {
$parcel$export(module.exports, "globalIssueCreateTTIWithAdjustments", () => $4ce0298162374e06$export$9f3d6f17e1da7874);
$parcel$export(module.exports, "startGlobalIssueCreateTTIWithAdjustments", () => $4ce0298162374e06$export$457c9fb71ad5b3a9);
$parcel$export(module.exports, "markGicTti", () => $4ce0298162374e06$export$ef664dac649a716c);
$parcel$export(module.exports, "stopTTI", () => $4ce0298162374e06$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $4ce0298162374e06$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $4ce0298162374e06$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $4ce0298162374e06$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $4ce0298162374e06$export$d86f4868694f2aa7);
/**
 * For issue view, we moved similar constants to view-specific packages.
 * However, for GIC, such a move causes a circular dependency with @atlassian/jira-packages-controllers-use-trigger-issue-create-modal package,
 * since view-specific/gic imports trigger points constants from @atlassian/jira-packages-controllers-use-trigger-issue-create-modal.
 * Therefore, for now, let's keep it here.
 */ 
var $hqYEY = parcelRequire("hqYEY");
const $4ce0298162374e06$export$9f3d6f17e1da7874 = (0, $hqYEY.metrics).interaction({
    key: 'global-issue-create-tti-with-adjustments',
    timings: [
        {
            key: 'gic-tti-delta',
            startMark: 'gic-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        },
        {
            key: 'gic-all-fields-tti',
            endMark: 'gic-all-fields-loaded'
        }
    ]
});
const $4ce0298162374e06$export$457c9fb71ad5b3a9 = ()=>{
    $4ce0298162374e06$export$9f3d6f17e1da7874.start();
};
const $4ce0298162374e06$export$ef664dac649a716c = ()=>$4ce0298162374e06$export$9f3d6f17e1da7874.mark('gic-tti');
const $4ce0298162374e06$export$30ca4c461fab486c = (customData)=>{
    $4ce0298162374e06$export$9f3d6f17e1da7874.stop({
        customData: customData
    });
};
const $4ce0298162374e06$export$27f2445288b528c = ()=>{
    $4ce0298162374e06$export$9f3d6f17e1da7874.cancel();
};
const $4ce0298162374e06$export$7a2709fc1e33401a = ()=>{
    $4ce0298162374e06$export$9f3d6f17e1da7874.mark('iframe-load');
};
const $4ce0298162374e06$export$cf3893335c93e33b = ()=>{
    $4ce0298162374e06$export$9f3d6f17e1da7874.mark('fields-registered');
};
const $4ce0298162374e06$export$d86f4868694f2aa7 = ()=>{
    $4ce0298162374e06$export$9f3d6f17e1da7874.mark('oninit-resolved');
};

});



parcelRegister("80UiT", function(module, exports) {
$parcel$export(module.exports, "usePersistentIssueCreateModalViewResource", () => $950c6fd53d168168$export$20dbed3226e737bc);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $9DB7T = parcelRequire("9DB7T");

var $eJrcF = parcelRequire("eJrcF");


var $cqUpU = parcelRequire("cqUpU");
const $950c6fd53d168168$export$20dbed3226e737bc = ()=>{
    const { data: data, update: update } = (0, $eJrcF.useResource)((0, $cqUpU.persistentIssueCreateModalViewResource));
    const updateView = (0, $eJOHy.useCallback)(async (view)=>{
        try {
            await (0, $9DB7T.userPreferenceAPI).set((0, $0f8f8ea7f8143316$export$15187a597cef02df), view);
            update((state)=>({
                    ...state,
                    view: view
                }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'persistentIssueCreateModalViewState',
                    packageName: 'jiraRouterResourcesPersistentIssueCreateModalView',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        update
    ]);
    const updateIsDiscoPushComplete = (0, $eJOHy.useCallback)(async (isDiscoPushComplete = true)=>{
        try {
            await (0, $9DB7T.userPreferenceAPI).set((0, $0f8f8ea7f8143316$export$8977f91a75d8d265), isDiscoPushComplete);
            update((state)=>({
                    ...state,
                    isDiscoPushComplete: isDiscoPushComplete
                }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'miniModalDiscoverabilityPushState',
                    packageName: 'jiraRouterResourcesPersistentIssueCreateModalView',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        update
    ]);
    return {
        data: data,
        updateView: updateView,
        updateIsDiscoPushComplete: updateIsDiscoPushComplete
    };
};

});
const $0f8f8ea7f8143316$export$15187a597cef02df = 'jira.user.gic.persistent.modal.view.state';
const $0f8f8ea7f8143316$export$8977f91a75d8d265 = 'jira.user.gic.mini.modal.discoverability';
const $0f8f8ea7f8143316$export$f658cfd591eb583e = 'RESOURCE_PERSISTENT_ISSUE_CREATE_MODAL_VIEW';



parcelRegister("dkTXM", function(module, exports) {
$parcel$export(module.exports, "NavigationCreateIssueButtonWrapperNudgeAsync", () => $0482641ed1be2c55$export$fc0840474cb1fce9);

var $eJOHy = parcelRequire("eJOHy");


var $kMreM = parcelRequire("kMreM");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $9CROC = parcelRequire("9CROC");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0482641ed1be2c55$var$NavigationCreateIssueButtonLazy = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("l4kog")).then((exportedModule)=>exportedModule.NavigationCreateIssueButtonWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-create-issue/index.tsx"
});
const $0482641ed1be2c55$export$fc0840474cb1fce9 = ({ children: children })=>{
    const shouldShowNudge = (0, $9CROC.useCanShowQuickstartNudge)();
    if (!shouldShowNudge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kMreM.OnboardingNudgeErrorBoundary), {
        id: (0, $2b839a8453de5367$export$aba87e019f5ccb8d),
        fallback: children,
        attributes: {
            nudgeId: (0, $2b839a8453de5367$export$aba87e019f5ccb8d)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "software-onboarding-navigation-create-issue-nudge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0482641ed1be2c55$var$NavigationCreateIssueButtonLazy, {
        nudgeId: (0, $2b839a8453de5367$export$aba87e019f5ccb8d)
    }, children)));
};

});
// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
const $2b839a8453de5367$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $2b839a8453de5367$export$e3884212029f7bef = 'should-show-welcome-modal';
const $2b839a8453de5367$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $2b839a8453de5367$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $2b839a8453de5367$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $2b839a8453de5367$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $2b839a8453de5367$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $2b839a8453de5367$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $2b839a8453de5367$export$6e69f8dc03075ef8 = 'team-type';
const $2b839a8453de5367$export$c06666264cd35603 = 'team-type-shorthand';
const $2b839a8453de5367$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $2b839a8453de5367$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $2b839a8453de5367$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $2b839a8453de5367$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $2b839a8453de5367$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $2b839a8453de5367$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $2b839a8453de5367$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $2b839a8453de5367$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $2b839a8453de5367$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $2b839a8453de5367$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $2b839a8453de5367$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $2b839a8453de5367$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $2b839a8453de5367$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $2b839a8453de5367$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $2b839a8453de5367$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $2b839a8453de5367$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $2b839a8453de5367$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $2b839a8453de5367$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $2b839a8453de5367$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $2b839a8453de5367$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $2b839a8453de5367$export$468488291ccd988 = 'timelineAddItemNudge';
const $2b839a8453de5367$export$7a33548109ac931d = 'createFormNudge';
const $2b839a8453de5367$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $2b839a8453de5367$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $2b839a8453de5367$export$594d3436316492be = 'summaryViewNudge';
const $2b839a8453de5367$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $2b839a8453de5367$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $2b839a8453de5367$export$baf21119361ffad = 'planCreateMoreWorkItemsNudge';
const $2b839a8453de5367$export$7fac0b950c128b4b = 'planConnectRelatedWorkNudge';
const $2b839a8453de5367$export$9fac41c1d8941795 = 'planShareYourPlanWithTheWorldTeamNudge';
const $2b839a8453de5367$export$994f00a8ff485faf = 'planShareYourPlanWithTheWorldAddPeopleNudge';
const $2b839a8453de5367$export$fc1e19da8853ecdc = 'planBringInTheTeamNudge';
const $2b839a8453de5367$export$d0ece87d6f260877 = 'planConfirmScopeNudge';
const $2b839a8453de5367$export$cc93e7cb8dd884fe = 'planCheckYourSettingsNudge';
const $2b839a8453de5367$export$b579a6f09436e23e = 'asyncPlanOnboardingTourNudge';
const $2b839a8453de5367$export$c7f7837470493c6f = 'planAdjustDetailsFieldsMenuNudge';
const $2b839a8453de5367$export$8909317d0f73beab = 'planAdjustDetailsFieldCellsNudge';
const $2b839a8453de5367$export$699265ec8ad9a740 = 'Software Development';
const $2b839a8453de5367$export$e07d1fa2da8ed874 = 'Customer Service';
const $2b839a8453de5367$export$76dcec3f438d9e56 = 'IT Support';
const $2b839a8453de5367$export$9a574c301f67ba30 = 'Human Resources';
const $2b839a8453de5367$export$363ec144a94029c8 = 'Finance';
const $2b839a8453de5367$export$df0fb32d68ae1e78 = 'Legal';
const $2b839a8453de5367$export$d9c0e3e59442fb4 = 'Marketing';
const $2b839a8453de5367$export$27dbc7d7ce66e6e3 = 'Operations';
const $2b839a8453de5367$export$a5dce388adf922bd = 'Sales';
const $2b839a8453de5367$export$e1473b31a257caff = 'Data Science';
const $2b839a8453de5367$export$85657457db93c2c2 = 'Product Management';
const $2b839a8453de5367$export$c0c2d1dfaeba89dd = 'Project Management';
const $2b839a8453de5367$export$2e6a7ad3ab9c82a3 = 'Design';
const $2b839a8453de5367$export$7b60378c3b4372e9 = 'Other or Personal';
const $2b839a8453de5367$export$572242e58bd07594 = 'CS';
const $2b839a8453de5367$export$d7de553940261eba = 'ITS';
const $2b839a8453de5367$export$4c29d0d04c15e55d = 'HR';
const $2b839a8453de5367$export$3950f7f841bf94b6 = 'FNC';
const $2b839a8453de5367$export$881249b988b6030f = 'LGL';
const $2b839a8453de5367$export$e4824f74b9879164 = 'MKT';
const $2b839a8453de5367$export$4f3cb0844009af52 = 'OPS';
const $2b839a8453de5367$export$1a65d50c4a641bb4 = 'SAL';
const $2b839a8453de5367$export$9ee64e8fbd8b03a2 = 'DS';
const $2b839a8453de5367$export$b8b1ac856ba1434b = 'DEV';
const $2b839a8453de5367$export$4f54a09a24fd1d74 = 'PDM';
const $2b839a8453de5367$export$79685802e8ff1098 = 'PJM';
const $2b839a8453de5367$export$e5c438b7501b5a24 = 'DES';
const $2b839a8453de5367$export$cbc0e551d91a692d = 'OTR';

parcelRegister("9CROC", function(module, exports) {
$parcel$export(module.exports, "useCanShowQuickstartNudge", () => $048e6c5f7b64d681$export$b687eb4905cdc15a);

var $5Xqpk = parcelRequire("5Xqpk");
const $048e6c5f7b64d681$export$b687eb4905cdc15a = ()=>{
    const [{ hasOpened: hasOpened }] = (0, $5Xqpk.useHasOpened)();
    return hasOpened;
};

});

parcelRegister("l4kog", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iXbSM").then(()=>parcelRequire('gytUr'));

});


parcelRegister("eU7vk", function(module, exports) {
$parcel$export(module.exports, "resetCache", () => $fbd5fc7ffb4125dd$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "resetCacheAsync", () => $fbd5fc7ffb4125dd$export$cd62f60830f74ae2);
$parcel$export(module.exports, "getClient", () => $fbd5fc7ffb4125dd$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $fbd5fc7ffb4125dd$export$8e363dbef886ff17);

var $eJOHy = parcelRequire("eJOHy");

var $9Dhvc = parcelRequire("9Dhvc");

var $688i3 = parcelRequire("688i3");
const $fbd5fc7ffb4125dd$var$CLIENTS_CACHE = {};
const $fbd5fc7ffb4125dd$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[clientId];
};
const $fbd5fc7ffb4125dd$export$cd62f60830f74ae2 = async (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    const client = $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[clientId];
    delete $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[clientId];
    await client?.clearStore();
};
const $fbd5fc7ffb4125dd$export$44dd3e9494f887fc = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($fbd5fc7ffb4125dd$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[key].extract()
        }), {});
const $fbd5fc7ffb4125dd$export$6bb76d6eba7e258c = ({ clientId: clientId, clientCreator: clientCreator })=>{
    let client = $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator();
        $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $fbd5fc7ffb4125dd$export$8e363dbef886ff17 extends (0, $eJOHy.Component) {
    getClient() {
        return $fbd5fc7ffb4125dd$export$6bb76d6eba7e258c(this.props.client);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        const client = this.getClient();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $688i3.ApolloProvider), {
            client: client
        }, children);
    }
}

});
parcelRegister("688i3", function(module, exports) {
$parcel$export(module.exports, "getApolloContext", () => $4769ebafec57fcc9$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $4769ebafec57fcc9$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $4769ebafec57fcc9$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $4769ebafec57fcc9$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $4769ebafec57fcc9$export$8f49e4af10703ce3);

var $eJOHy = parcelRequire("eJOHy");

var $lDEi6 = parcelRequire("lDEi6");
var $4769ebafec57fcc9$var$apolloContext;
function $4769ebafec57fcc9$export$a47505d961ee3a1() {
    if (!$4769ebafec57fcc9$var$apolloContext) $4769ebafec57fcc9$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({});
    return $4769ebafec57fcc9$var$apolloContext;
}
function $4769ebafec57fcc9$export$c2ee824bcc89ca6a() {
    $4769ebafec57fcc9$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({});
}
var $4769ebafec57fcc9$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $4769ebafec57fcc9$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $lDEi6.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $4769ebafec57fcc9$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $4769ebafec57fcc9$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $lDEi6.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $4769ebafec57fcc9$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($4769ebafec57fcc9$export$d1d99cf900472499 || ($4769ebafec57fcc9$export$d1d99cf900472499 = {}));
var $4769ebafec57fcc9$var$cache = new Map();
function $4769ebafec57fcc9$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $4769ebafec57fcc9$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $4769ebafec57fcc9$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $4769ebafec57fcc9$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $4769ebafec57fcc9$export$8f49e4af10703ce3(document) {
    var cached = $4769ebafec57fcc9$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $lDEi6.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $lDEi6.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $lDEi6.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $4769ebafec57fcc9$export$d1d99cf900472499.Query : $4769ebafec57fcc9$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $4769ebafec57fcc9$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $lDEi6.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $4769ebafec57fcc9$var$cache.set(document, payload);
    return payload;
}

});
parcelRegister("lDEi6", function(module, exports) {
$parcel$export(module.exports, "InvariantError", () => $fc0c7e72915b693a$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $fc0c7e72915b693a$export$f5708dca728d7177);

var $dnskZ = parcelRequire("dnskZ");

var $igDjg = parcelRequire("igDjg");
var $fc0c7e72915b693a$var$genericMessage = "Invariant Violation";
var $fc0c7e72915b693a$var$_a = Object.setPrototypeOf, $fc0c7e72915b693a$var$setPrototypeOf = $fc0c7e72915b693a$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $fc0c7e72915b693a$var$_a;
var $fc0c7e72915b693a$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $dnskZ.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $fc0c7e72915b693a$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $fc0c7e72915b693a$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $fc0c7e72915b693a$var$genericMessage;
        $fc0c7e72915b693a$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $fc0c7e72915b693a$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $fc0c7e72915b693a$export$cea12affaee22fe8(message);
}
function $fc0c7e72915b693a$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $fc0c7e72915b693a$var$wrapConsoleMethod("warn");
    invariant.error = $fc0c7e72915b693a$var$wrapConsoleMethod("error");
})($fc0c7e72915b693a$export$f5708dca728d7177 || ($fc0c7e72915b693a$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $fc0c7e72915b693a$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $igDjg === "object") $fc0c7e72915b693a$export$e54fe5b0f43758f7 = $igDjg;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($fc0c7e72915b693a$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $fc0c7e72915b693a$var$invariant$1 = $fc0c7e72915b693a$export$f5708dca728d7177;
var $fc0c7e72915b693a$export$2e2bcd8739ae039 = $fc0c7e72915b693a$var$invariant$1;

});



const $bd25ba88693dbfbe$export$2eeebb625d70ae49 = 'SWAG';
const $bd25ba88693dbfbe$export$9c9ee93e509f8666 = 'gira';
const $bd25ba88693dbfbe$export$14a05c678c2af272 = 'REST';
const $bd25ba88693dbfbe$export$b19c7b383ca04a4d = 'POLARIS';

parcelRegister("4pSRi", function(module, exports) {
$parcel$export(module.exports, "createPopupEntryPoint", () => $5d4fafaf710b077f$export$1b98ff3880258d5f);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $5d4fafaf710b077f$export$1b98ff3880258d5f = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("eIUU9")), {
        moduleId: "19ede63b",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            queries: {}
        })
});

});
parcelRegister("eIUU9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("3yAl4"),
    $ewTvA("kNFvF"),
    $ewTvA("fliVL"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("cjW6R")
]).then(()=>parcelRequire('bFvNE'));

});


parcelRegister("4NkR0", function(module, exports) {
$parcel$export(module.exports, "CreatePopupContainer", () => $b8ed0c2138cf04dd$export$30c213f09faf3438);
/* create-popup-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $b8ed0c2138cf04dd$export$30c213f09faf3438 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(// eslint-disable-line @typescript-eslint/no-explicit-any
({ children: children, ...props }, ref)=>/*#__PURE__*/ $eJOHy.createElement("div", {
        ...props,
        ref: ref,
        className: (0, $hcewu.default)([
            $b8ed0c2138cf04dd$var$styles.popup
        ])
    }, children));
// Custom shadow value required for design spec
const $b8ed0c2138cf04dd$var$POPUP_SHADOW = '0 0 1px 0 rgba(30, 31, 33, 0.31), 0 8px 12px 0 rgba(30, 31, 33, 0.15)';
const $b8ed0c2138cf04dd$var$styles = {
    popup: "_1reoewfl _18m9ewfl _2rko1qi0 _bfhkvuon _16qs5pg2"
};

});

parcelRegister("cgeq2", function(module, exports) {
$parcel$export(module.exports, "Create", () => $5b89414d4be457db$export$8ade6fcbf3a7de5d);

var $eJOHy = parcelRequire("eJOHy");

var $2ntmI = parcelRequire("2ntmI");

var $8IeH1 = parcelRequire("8IeH1");

var $7rjYb = parcelRequire("7rjYb");

var $kJPDw = parcelRequire("kJPDw");

var $4cTDP = parcelRequire("4cTDP");

var $eES78 = parcelRequire("eES78");

var $gQZTc = parcelRequire("gQZTc");

var $5qLQO = parcelRequire("5qLQO");

var $e6YEs = parcelRequire("e6YEs");

var $cHtIB = parcelRequire("cHtIB");

var $cGMXY = parcelRequire("cGMXY");

var $lb6FK = parcelRequire("lb6FK");

const $5b89414d4be457db$export$8ade6fcbf3a7de5d = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const accountId = (0, $e6YEs.useAccountId)() ?? '';
    const orgId = (0, $cGMXY.useOrgId)() ?? '';
    const { data: data } = (0, $lb6FK.useRovoEntitlementResource)();
    const shouldShowCreateWithAiDropdown = (data?.isRovoLLMEnabled && (0, $4cTDP.fg)('jira_aifc_enabled')) ?? false;
    // This feature gate disables the server-specific code path, aligning SSR and CSR content for hydration
    if (false && !(0, $4cTDP.fg)('jfp-magma-4013-fix-top-nav-ssr-hydration')) {
        if (shouldShowCreateWithAiDropdown) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ntmI.SplitButton), {
            appearance: "primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJPDw.CreateButton), {
            ref: ref,
            testId: (0, $d1eda76f6de7b0a1$export$c65f84387a2a60c)
        }, props.text), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
            shouldRenderToParent: true
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJPDw.CreateButton), {
            ref: ref,
            testId: (0, $d1eda76f6de7b0a1$export$bac9f330cf4670e8)
        }, props.text);
    }
    const { onClick: onClick, text: text } = props;
    if (shouldShowCreateWithAiDropdown) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gQZTc.SpotlightTarget), {
        name: (0, $eES78.GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ntmI.SplitButton), {
        appearance: "primary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJPDw.CreateButton), {
        ref: ref,
        onClick: onClick,
        testId: (0, $d1eda76f6de7b0a1$export$c65f84387a2a60c)
    }, text), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qLQO.CreateWithAIDropdown), {
        cloudId: cloudId,
        accountId: accountId,
        orgId: orgId
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gQZTc.SpotlightTarget), {
        name: (0, $eES78.GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJPDw.CreateButton), {
        ref: ref,
        onClick: onClick,
        testId: (0, $d1eda76f6de7b0a1$export$bac9f330cf4670e8)
    }, text)));
});

});
parcelRegister("2ntmI", function(module, exports) {
$parcel$export(module.exports, "SplitButton", () => $f424517b2b03f7a5$export$651ad66661acd392);
/* split-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k51XY = parcelRequire("k51XY");

var $kUUEq = parcelRequire("kUUEq");
const $f424517b2b03f7a5$var$dividerStyles = {
    baseDivider: "_1bsbe4h9 _kqswh2mm _1pbykb7n",
    dividerDisabled: "_bfhk9xzm _80om13gf",
    dividerOffset: "_195g1n1a"
};
const $f424517b2b03f7a5$var$dividerAppearanceStyles = {
    default: "_bfhkmuej",
    primary: "_bfhkveue _tzy41wzo",
    navigation: "_1mouu2gc _195g1h5n _4t3i7vkz _bfhkdud1 _tzy419lr"
};
const $f424517b2b03f7a5$var$dividerHeightStyles = {
    default: "_4t3iviql",
    compact: "_4t3i1k8s"
};
// The divider height is calculated by subtracting twice the border width from the button height.
// This ensures the divider does not intersect with the button's border, avoiding visual issues
// caused by overlapping alpha colors (color.border) at the intersection.
const $f424517b2b03f7a5$var$defaultDividerHeightStyles = {
    default: "_4t3im1ee",
    compact: "_4t3i1hvu"
};
const $f424517b2b03f7a5$export$2e0a83ec2e27ecbb = ({ appearance: appearance, spacing: spacing, isDisabled: isDisabled = false })=>{
    const isDefaultDivider = appearance === 'default' && !isDisabled;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            $f424517b2b03f7a5$var$dividerStyles.baseDivider,
            isDefaultDivider && $f424517b2b03f7a5$var$defaultDividerHeightStyles[spacing],
            !isDefaultDivider && $f424517b2b03f7a5$var$dividerHeightStyles[spacing],
            isDisabled && $f424517b2b03f7a5$var$dividerStyles.dividerDisabled,
            !isDisabled && $f424517b2b03f7a5$var$dividerAppearanceStyles[appearance],
            $f424517b2b03f7a5$var$dividerStyles.dividerOffset
        ])
    });
};
const $f424517b2b03f7a5$var$buttonStyles = {
    splitButton: "_1e0c116y _kqswh2mm _4cvr1h6o _o5721q9c",
    primaryButton: "_traeidpf _anlpidpf _p9ykidpf _bepvidpf",
    secondaryButton: "_1j4hidpf _1553idpf _1qgbidpf _y1n3idpf",
    defaultAppearanceContainer: "_2rkofajl _12ji1l7x _1cwg1n1a _1qu2nqa1 _12y3t94y",
    defaultAppearanceDisabledContainer: "_12jibk0g"
};
const $f424517b2b03f7a5$export$994ba1b4c598f7 = ({ appearance: appearance, children: children, isDisabled: isDisabled = false })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            appearance === 'default' && $f424517b2b03f7a5$var$buttonStyles.defaultAppearanceContainer,
            appearance === 'default' && isDisabled && $f424517b2b03f7a5$var$buttonStyles.defaultAppearanceDisabledContainer,
            $f424517b2b03f7a5$var$buttonStyles.splitButton
        ]),
        children: children
    });
};
const $f424517b2b03f7a5$export$651ad66661acd392 = ({ children: children, appearance: appearance = 'default', spacing: spacing = 'default', isDisabled: isDisabled = false })=>{
    const { PrimaryAction: PrimaryAction, SecondaryAction: SecondaryAction } = (0, $kUUEq.getActions)(children);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($f424517b2b03f7a5$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $k51XY.SplitButtonContext).Provider, {
            value: {
                appearance: appearance,
                spacing: spacing,
                isDisabled: isDisabled
            },
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $f424517b2b03f7a5$var$buttonStyles.primaryButton
                    ]),
                    children: PrimaryAction
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)($f424517b2b03f7a5$export$2e0a83ec2e27ecbb, {
                    appearance: appearance,
                    spacing: spacing,
                    isDisabled: isDisabled
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $f424517b2b03f7a5$var$buttonStyles.secondaryButton
                    ]),
                    children: SecondaryAction
                })
            ]
        })
    });
};
const $f424517b2b03f7a5$export$e3ca81100b492e15 = ({ primaryAction: primaryAction, secondaryAction: secondaryAction, appearance: appearance = 'default', spacing: spacing = 'default', isDisabled: isDisabled = false })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($f424517b2b03f7a5$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $k51XY.SplitButtonContext).Provider, {
            value: {
                appearance: appearance,
                spacing: spacing,
                isDisabled: isDisabled
            },
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $f424517b2b03f7a5$var$buttonStyles.primaryButton
                    ]),
                    children: primaryAction
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)($f424517b2b03f7a5$export$2e0a83ec2e27ecbb, {
                    appearance: appearance,
                    spacing: spacing,
                    isDisabled: isDisabled
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $f424517b2b03f7a5$var$buttonStyles.secondaryButton
                    ]),
                    children: secondaryAction
                })
            ]
        })
    });
};

});
parcelRegister("kUUEq", function(module, exports) {
$parcel$export(module.exports, "getActions", () => $17ccf685d98bc901$export$fe3955935f564b31);

var $eJOHy = parcelRequire("eJOHy");

var $igDjg = parcelRequire("igDjg");
const $17ccf685d98bc901$export$fe3955935f564b31 = (children)=>{
    const [PrimaryAction, SecondaryAction] = (0, $eJOHy.Children).toArray(children);
    typeof $igDjg;
    return {
        PrimaryAction: PrimaryAction,
        SecondaryAction: SecondaryAction
    };
};

});


parcelRegister("kJPDw", function(module, exports) {
$parcel$export(module.exports, "CreateButton", () => $622ec57f9027206b$export$6d3c345ce7c38fd9);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $dcLzM = parcelRequire("dcLzM");

var $6kf2c = parcelRequire("6kf2c");
const $622ec57f9027206b$export$6d3c345ce7c38fd9 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, onClick: onClick, testId: testId, interactionName: interactionName }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $6kf2c.Button), {
        ref: ref,
        appearance: "primary",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))),
        onClick: onClick,
        testId: testId,
        interactionName: interactionName,
        children: children
    }));

});
parcelRegister("dcLzM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16076dcc8358b4ceed39bd4386a6c9a2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $99d14cf5bc56a085$var$_react = $99d14cf5bc56a085$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $99d14cf5bc56a085$var$_baseNew = $99d14cf5bc56a085$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $99d14cf5bc56a085$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $99d14cf5bc56a085$var$AddIcon = (props)=>/*#__PURE__*/ $99d14cf5bc56a085$var$_react.default.createElement($99d14cf5bc56a085$var$_baseNew.default, Object.assign({
        name: "AddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 8.75V15h1.5V8.75H15v-1.5H8.75V1h-1.5v6.25H1v1.5z" clip-rule="evenodd"/>`
    }, props));
$99d14cf5bc56a085$var$AddIcon.displayName = 'AddIcon';
var $99d14cf5bc56a085$var$_default = module.exports.default = $99d14cf5bc56a085$var$AddIcon;

});


parcelRegister("eES78", function(module, exports) {
$parcel$export(module.exports, "REPO_TYPE", () => $52e041f2c33cd742$export$399c7e6858236b4);
$parcel$export(module.exports, "LINK_TYPE", () => $52e041f2c33cd742$export$58125ce2bb1c3378);
$parcel$export(module.exports, "EMOJI_REGEX", () => $52e041f2c33cd742$export$c79ed2783644934c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES", () => $52e041f2c33cd742$export$25ae65041c800c9);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES", () => $52e041f2c33cd742$export$e03c9beea817d44b);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES", () => $52e041f2c33cd742$export$3d575bdf28c0d17c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES", () => $52e041f2c33cd742$export$af84baced6970a17);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES", () => $52e041f2c33cd742$export$c767f253046b1ea7);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES", () => $52e041f2c33cd742$export$265b9384cc2dfbd4);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES", () => $52e041f2c33cd742$export$2de77b357e71c7a7);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES", () => $52e041f2c33cd742$export$7de7abb92169d6c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES", () => $52e041f2c33cd742$export$fd7df8bd7600c65c);
$parcel$export(module.exports, "GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID", () => $52e041f2c33cd742$export$dde074e512e80dff);
$parcel$export(module.exports, "REPORTS_IDS", () => $52e041f2c33cd742$export$1f70a76cb421b107);
$parcel$export(module.exports, "SIDEBAR_EXPERIENCE", () => $52e041f2c33cd742$export$71aaf2625ee54d10);
$parcel$export(module.exports, "staticLegacyIds", () => $52e041f2c33cd742$export$f57650e6e7be03dc);
const $52e041f2c33cd742$export$399c7e6858236b4 = 'source.code.link';
const $52e041f2c33cd742$export$58125ce2bb1c3378 = 'project.shortcut.default.link';
const $52e041f2c33cd742$export$c79ed2783644934c = /^(?:[\u2600-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/;
const $52e041f2c33cd742$export$25ae65041c800c9 = 'pin-filter-myopenissues';
const $52e041f2c33cd742$export$e03c9beea817d44b = 'pin-filter-reportedbyme';
const $52e041f2c33cd742$export$3d575bdf28c0d17c = 'pin-filter-allissues';
const $52e041f2c33cd742$export$af84baced6970a17 = 'pin-filter-allopenissues';
const $52e041f2c33cd742$export$c767f253046b1ea7 = 'pin-filter-doneissues';
const $52e041f2c33cd742$export$265b9384cc2dfbd4 = 'pin-filter-recentlyviewed';
const $52e041f2c33cd742$export$2de77b357e71c7a7 = 'pin-filter-addedrecently';
const $52e041f2c33cd742$export$7de7abb92169d6c = 'pin-filter-resolvedrecently';
const $52e041f2c33cd742$export$fd7df8bd7600c65c = 'pin-filter-updatedrecently';
const $52e041f2c33cd742$export$dde074e512e80dff = 'global-create-spotlight';
const $52e041f2c33cd742$export$1f70a76cb421b107 = {
    REPORTS_ADDONS: 'sd-reports-addons'
};
const $52e041f2c33cd742$export$71aaf2625ee54d10 = 'viewSidebarNavigation';
const $52e041f2c33cd742$export$f57650e6e7be03dc = [
    // Global Settings Static Legacy Ids
    'general_configuration',
    'dark_features',
    'troubleshooting_and_support',
    'view_auditing',
    'pluginViewer',
    'pluginViewer',
    'system_info',
    'integrity_checker',
    'logging_profiling',
    'scheduler_details',
    'security_section',
    'project_role_browser',
    'global_permissions',
    'collectors',
    'user_interface',
    'user_defaults',
    'edit_default_dashboard',
    'lookandfeel',
    'com.atlassian.pas:pas-admin-link-jira',
    'import_export_section',
    'vertigo_export',
    'external_import',
    'vertigo_import',
    'vertigo_import_jira_cloud',
    'vertigo_import_jira_server',
    'mail_section',
    'global_mail_settings',
    'outgoing_mail',
    'incoming_mail',
    'send_email',
    'admin-helper-admin-section',
    'permissionhelper-admin-page',
    'notificationhelper-admin-page',
    'shared_section',
    'shared_filters',
    'shared_dashboards',
    'advanced_section',
    'attachments',
    'eventtypes',
    'webhooks-admin',
    'services',
    'manage_dashboards',
    'manage_filters',
    'greenhopper-lexorank-manage',
    // Project Settings Static Legacy Ids
    'jira.webfragments.view.project.operations:edit_project',
    'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
    'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
    'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
    'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
    'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
    'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
    'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
    'com.atlassian.jira.jira-projects-plugin:administer_project_components',
    'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
    'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
    'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
    'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
    'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation.moderate__cb-automation-project-config',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
    'com.atlassian.jira.jira-projects-plugin:administer_project_code',
    'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
    'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
    'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
    'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
    'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
    'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
    'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
    'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
    'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
    'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
    'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
    'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
    // Automation connect item
    'com.codebarrel.addons.automation__cb-automation',
    'com.codebarrel.addons.automation.moderate__cb-automation'
];

});

parcelRegister("gQZTc", function(module, exports) {
$parcel$export(module.exports, "SpotlightTarget", () => $53951e7fd16438ee$export$e29577842f211e22);

var $eJOHy = parcelRequire("eJOHy");

var $guChT = parcelRequire("guChT");

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");

var $dZidf = parcelRequire("dZidf");
const $53951e7fd16438ee$var$SpotlightTargetWrapper = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-test-id": `ak-spotlight-target-${props.name}`
    }, children));
const $53951e7fd16438ee$var$SpotlightTargetOld = (0, $dZidf.withNestingOptimisation)($53951e7fd16438ee$var$SpotlightTargetWrapper);
const $53951e7fd16438ee$export$e29577842f211e22 = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('jfp-magma-4013-fix-top-nav-ssr-hydration'), $53951e7fd16438ee$var$SpotlightTargetWrapper, $53951e7fd16438ee$var$SpotlightTargetOld);

});

parcelRegister("5qLQO", function(module, exports) {
$parcel$export(module.exports, "CreateWithAIDropdown", () => $ad11425ca47d5f1a$export$5603aada1ff22587);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $7rjYb = parcelRequire("7rjYb");
var $aLJ1L = parcelRequire("aLJ1L");

var $lgMTT = parcelRequire("lgMTT");

var $eGOwo = parcelRequire("eGOwo");

var $9KVrd = parcelRequire("9KVrd");
var $eJJ08 = parcelRequire("eJJ08");

var $anrJM = parcelRequire("anrJM");

var $3i88T = parcelRequire("3i88T");

var $6Tum0 = parcelRequire("6Tum0");
const $ad11425ca47d5f1a$var$DATA_TEST_ID = 'jira-smart-creation.ui.create-with-ai.dropdown';
const $ad11425ca47d5f1a$export$5603aada1ff22587 = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const experienceTracker = (0, $eJJ08.useAIMateExperienceTracker)();
    const returnFocusRef = (0, $eJOHy.useRef)(null);
    const handleOpenChange = (0, $eJOHy.useCallback)(({ isOpen: isOpen })=>{
        if (isOpen) experienceTracker.start({
            name: (0, $9KVrd.ExperienceName).AIFC_LOAD_STAGING_AREA_MODAL,
            id: (0, $9KVrd.ExperienceName).AIFC_LOAD_STAGING_AREA_MODAL,
            attributes: {
                product: 'jira'
            }
        });
    }, [
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rjYb.default), {
        testId: $ad11425ca47d5f1a$var$DATA_TEST_ID,
        onOpenChange: handleOpenChange,
        returnFocusRef: returnFocusRef,
        label: (0, $eGOwo.fg)('blu-8547_fix_a11y_violation_button_name_nav') ? formatMessage((0, $6Tum0.messages).dropdownLabel) : undefined,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aLJ1L.default), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $anrJM.ModalDropdownItemTrigger), {
                entryPoint: (0, $3i88T.jiraSmartCreationEntrypoint),
                entryPointProps: props,
                elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.RovoIcon), {
                    size: "xsmall"
                }),
                children: formatMessage((0, $6Tum0.messages).createWithAIItem)
            })
        })
    });
};

});
parcelRegister("9KVrd", function(module, exports) {
$parcel$export(module.exports, "ExperienceName", () => $71283c83f06445ec$export$b881bd9f00ed8ed1);
$parcel$export(module.exports, "ExperienceNamePostfix", () => $71283c83f06445ec$export$3615d040a39afa1e);
$parcel$export(module.exports, "sendMessageExperienceName", () => $71283c83f06445ec$export$97bfa295b10f6f9e);
const $71283c83f06445ec$export$b881bd9f00ed8ed1 = {
    LOAD_PANEL: 'aiMateLoadPanel',
    LOAD_BROWSE_AGENTS: 'aiMateLoadBrowseAgents',
    LOAD_CREATE_AGENT: 'aiMateLoadCreateAgent',
    FETCH_CHAT: 'aiMateFetchChat',
    FETCH_AGENTS: 'aiMateFetchAgents',
    FETCH_AGENTS_PAGINATED: 'aiMateFetchAgentsPaginated',
    FETCH_AGENTS_OVERRIDES: 'aiMateFetchAgentsOverrides',
    FETCH_AGENT_BY_AGENT_ID: 'aiMateFetchAgentByAgentId',
    FETCH_SCENARIO_LIST: 'aiMateFetchScenarioList',
    FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID: 'aiMateFetchAgentByIdentityAccountId',
    FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE: 'aiMateFetchAgentByExternalConfigReference',
    FETCH_AGENT_DEBUG_MODAL_DATA: 'aiMateFetchAgentDebugModalData',
    CREATE_AGENT: 'aiMateCreateAgent',
    UPDATE_AGENT: 'aiMateUpdateAgent',
    DELETE_AGENT: 'aiMateDeleteAgent',
    HYDRATE_AGENT_DATA: 'aiMateHydrateAgentData',
    FAVOURITE_AGENT: 'aiMateFavouriteAgent',
    UNFAVOURITE_AGENT: 'aiMateUnfavouriteAgent',
    CLEAR_CHAT: 'aiMateClearChat',
    SEND_MESSAGE: 'aiMateSendMessage',
    SEND_MESSAGE_ROVO_CUSTOM_AGENT: 'aiMateSendMessageRovoCustomAgent',
    SEND_DR_MESSAGE: 'aiMateSendDRMessage',
    SEND_TD_MESSAGE: 'aiMateSendThinkDeeperMessage',
    SEND_CONFIRMED_TOOLS_MESSAGE: 'aiMateSendConfirmedToolsMessage',
    ABORT_AGENT_STREAM: 'aiMateAbortAgentStream',
    GET_CONVERSATION_CHANNELS: 'aiMateGetConversationChannels',
    GET_CONVERSATION_CHANNELS_INITIAL_LOAD: 'aiMateGetConversationChannelsInitialLoad',
    UPDATE_CONVERSATION_CHANNEL: 'aiMateUpdateConversationChannel',
    CREATE_SEEDED_CONVERSATION_CHANNEL: 'aiMateCreateSeededConversationChannel',
    PUBSUB_LISTENER: 'aiMatePubSubListener',
    FETCH_AGENT_TENANT_DATA: 'aiMateFetchAgentTenantData',
    RESOLVE_CONVERSATION_ACTION: 'aiMateResolveConversationAction',
    MESSAGE_RENDERER: 'aiMateMessageRenderer',
    FETCH_CONTEXTUAL_STARTERS: 'aiMateFetchContextualStarters',
    FETCH_DYNAMIC_CONVERSATION_STARTERS: 'aiMateFetchDynamicConversationStarters',
    GENERATE_CONVERSATION_STARTERS: 'aiMateGenerateConversationStarters',
    FETCH_AGENT_TEAM_DATA: 'aiMateFetchAgentTeamData',
    FETCH_CONNECTED_KNOWLEDGE_SOURCES: 'aiMateFetchConnectedKnowledgeSources',
    FETCH_AGENT_ACTIONS: 'aiMateFetchAgentActions',
    CHANGE_AGENT_OWNER: 'aiMateChangeAgentOwner',
    GET_AGENT_PERMISSIONS: 'aiMateGetAgentPermissions',
    AIFC_FINALIZE_CONTENT: 'aiMateAIFCFinalizeContent',
    PREVIEW_CONTENT: 'aiMatePreviewContent',
    PREVIEW_CARD_RENDER: 'aiMatePreviewCardRender',
    FETCH_AGENT_SITE_PERMISSIONS: 'aiMateFetchAgentSitePermissions',
    SEND_MESSAGE_NL_AGENT: 'aiMateSendMessageNLAgent',
    GET_RECOMMENDED_AGENTS: 'aiMateGetRecommendedAgents',
    UPLOAD_FILES_TO_CONVERSATION: 'aiMateUploadFilesToConversation',
    VALIDATE_FILES: 'aiMateValidateFiles',
    GET_CONVERSATION_FILES: 'aiMateGetConversationFiles',
    AIFC_MESSAGE: 'aiMateAifcMessage',
    AIFC_LOAD_STAGING_AREA_MODAL: 'aiMateLoadStagingAreaModal',
    AIFC_GENERATE_CONTENT: 'aiMateAifcGenerateContent',
    AIFC_GENERATE_CONTENT_IN_CHAT: 'aiMateAifcGenerateContentInChat',
    AIFC_INITIAL_DATA_RECEIVED: 'aiMateAifcInitialDataReceived',
    AIFC_ALL_DATA_HANDLED: 'aiMateAifcAllDataHandled',
    AIFC_UPDATE_CONTENT: 'aiMateAifcUpdateContent',
    CSM_WIDGET_RENDER: 'csmWidgetRender',
    CSM_AGENT_IDENTITY_NAME: 'csmAgentIdentityName',
    CSM_AGENT_IDENTITY_COMPANY: 'csmAgentIdentityCompany',
    CSM_AGENT_IDENTITY_TONE: 'csmAgentIdentityTone',
    CSM_AGENT_IDENTITY_GREETING_MESSAGE: 'csmAgentIdentityGreetingMessage',
    CSM_AGENT_IDENTITY_CONVERSATION_STARTERS: 'csmAgentIdentityConversationStarters',
    CSM_AGENT_IDENTITY_GENERATE_CONVERSATION_STARTERS: 'csmAgentIdentityGenerateConversationStarters',
    GET_AUTO_APPLY_STATE: 'aiMateGetAutoApplyState',
    SET_AUTO_APPLY_STATE: 'aiMateSetAutoApplyState'
};
var $71283c83f06445ec$export$3615d040a39afa1e = /*#__PURE__*/ function(ExperienceNamePostfix) {
    ExperienceNamePostfix["MINI_MODAL"] = "miniModal";
    return ExperienceNamePostfix;
}({});
const $71283c83f06445ec$export$97bfa295b10f6f9e = ({ deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, isCustomRovoAgent: isCustomRovoAgent })=>{
    if (isCustomRovoAgent) return $71283c83f06445ec$export$b881bd9f00ed8ed1.SEND_MESSAGE_ROVO_CUSTOM_AGENT;
    if (deepResearchEnabled) return $71283c83f06445ec$export$b881bd9f00ed8ed1.SEND_DR_MESSAGE;
    if (thinkDeeperEnabled) return $71283c83f06445ec$export$b881bd9f00ed8ed1.SEND_TD_MESSAGE;
    return $71283c83f06445ec$export$b881bd9f00ed8ed1.SEND_MESSAGE;
};
const $71283c83f06445ec$export$233a4307e330ea30 = [
    $71283c83f06445ec$export$b881bd9f00ed8ed1.AIFC_GENERATE_CONTENT,
    $71283c83f06445ec$export$b881bd9f00ed8ed1.AIFC_GENERATE_CONTENT_IN_CHAT,
    $71283c83f06445ec$export$b881bd9f00ed8ed1.AIFC_UPDATE_CONTENT,
    $71283c83f06445ec$export$b881bd9f00ed8ed1.AIFC_FINALIZE_CONTENT,
    $71283c83f06445ec$export$b881bd9f00ed8ed1.AIFC_LOAD_STAGING_AREA_MODAL
];
const $71283c83f06445ec$export$449b821dadec8760 = [
    // Experiences with timeouts must be listed first:
    $71283c83f06445ec$export$b881bd9f00ed8ed1.AIFC_INITIAL_DATA_RECEIVED,
    // Experiences without timeouts:
    $71283c83f06445ec$export$b881bd9f00ed8ed1.AIFC_ALL_DATA_HANDLED,
    $71283c83f06445ec$export$b881bd9f00ed8ed1.PREVIEW_CONTENT,
    ...$71283c83f06445ec$export$233a4307e330ea30
];

});

parcelRegister("eJJ08", function(module, exports) {
$parcel$export(module.exports, "useUFOLabelStackSetter", () => $d93500c013ebdd7b$export$63af6e7bbb4f375d);
$parcel$export(module.exports, "useAIMateExperienceTracker", () => $d93500c013ebdd7b$export$412c53791574f6f0);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $eGOwo = parcelRequire("eGOwo");

var $2QO3b = parcelRequire("2QO3b");

var $87Obl = parcelRequire("87Obl");

var $7t81K = parcelRequire("7t81K");

var $aSa0e = parcelRequire("aSa0e");

var $9tFw2 = parcelRequire("9tFw2");

var $9KVrd = parcelRequire("9KVrd");
const $d93500c013ebdd7b$var$isRovoInstrumentedError = (error)=>error && typeof error === 'object' && 'errorAttributes' in error && typeof error.errorAttributes === 'object';
class $d93500c013ebdd7b$var$ExperienceTrackerHandler {
    static{
        this.labelStack = [];
    }
    constructor(){
        this.experienceTracker = new (0, $87Obl.ExperienceTracker)();
        this.sendAnalyticsEvent = null;
        this.experienceTracker.subscribe((event)=>{
            let filteredErrorAttributes = {};
            const isExtendedErrorTracking = (0, $eGOwo.fg)('rovo_extended_error_tracking');
            let preventSendingLogException = false;
            // for FailEvent
            if ('error' in event) {
                // do not fail experience tracking if the error is a client fetch error
                if ((0, $7t81K.isClientFetchError)(event.error)) preventSendingLogException = true;
                if (event.attributes) {
                    const { webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled } = event.attributes;
                    if (webSearchEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        webSearchEnabled: webSearchEnabled
                    };
                    if (deepResearchEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        deepResearchEnabled: deepResearchEnabled
                    };
                    if (thinkDeeperEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        thinkDeeperEnabled: thinkDeeperEnabled
                    };
                }
                if ($d93500c013ebdd7b$var$isRovoInstrumentedError(event.error)) {
                    const errorAttributes = event.error.errorAttributes;
                    // Remove undefined properties
                    filteredErrorAttributes = Object.fromEntries(Object.entries(errorAttributes).filter(([_, value])=>value !== undefined));
                    // Filter 5xx errors since backend monitoring will cover this
                    // as per https://hello.atlassian.net/wiki/spaces/CONVAI/pages/3547354267/Meeting+notes+FE+SLOs+which+one+to+promote
                    if (errorAttributes?.statusCode && errorAttributes?.statusCode >= 500 && !isExtendedErrorTracking) preventSendingLogException = true;
                }
                if (!preventSendingLogException) {
                    const error = event.error instanceof Error ? event.error : new Error(JSON.stringify(event.error));
                    const attributes = event.attributes;
                    // this is added by `useExperienceTracker` below
                    const touchpointSource = attributes?.touchpointSource;
                    const teamName = attributes?.teamName;
                    (0, $aSa0e.logException)({
                        exception: error,
                        name: event.name,
                        tags: {
                            source: 'aiMateExperienceTracker',
                            ...filteredErrorAttributes,
                            ...touchpointSource && {
                                touchpointSource: touchpointSource
                            },
                            ...teamName && {
                                teamName: teamName
                            }
                        }
                    });
                }
            }
            // Track all failed events via analytics when isExtendedErrorTracking
            if (!preventSendingLogException || isExtendedErrorTracking) {
                if (event.action === 'taskSuccess' || event.action === 'taskFail' || event.action === 'taskAbort') // the experience tracker already uses performance.now() to calculate the duration, so we can just piggyback on that,
                // we will loose some precision due to rounding of duration, but it's good enough for our purposes
                (0, $2QO3b.addSpanToAll)('custom', `exp-${event.name}`, $d93500c013ebdd7b$var$ExperienceTrackerHandler.labelStack, event.startTime, event.startTime + event.duration);
                this.sendAnalyticsEvent?.({
                    eventType: 'operational',
                    action: event.action,
                    actionSubject: 'ui',
                    attributes: {
                        task: event.name,
                        taskId: event.id,
                        startTime: event.startTime,
                        // Only add duration if event is SuccessEvent or FailEvent
                        ...(event.action === 'taskSuccess' || event.action === 'taskFail') && {
                            duration: event.duration
                        },
                        ...event.action === 'taskFail' && {
                            error: event.error.message,
                            ...filteredErrorAttributes
                        },
                        ...event.attributes
                    }
                }, {
                    removeDefaultTags: true
                });
            }
        });
    }
    setSendAnalyticsEvent(sendAnalyticsEvent) {
        this.sendAnalyticsEvent = sendAnalyticsEvent;
    }
    static getInstance() {
        if (!$d93500c013ebdd7b$var$ExperienceTrackerHandler.instance) $d93500c013ebdd7b$var$ExperienceTrackerHandler.instance = new $d93500c013ebdd7b$var$ExperienceTrackerHandler();
        return $d93500c013ebdd7b$var$ExperienceTrackerHandler.instance;
    }
    static setLabelStack(labelStack) {
        $d93500c013ebdd7b$var$ExperienceTrackerHandler.labelStack = labelStack;
    }
}
const $d93500c013ebdd7b$export$63af6e7bbb4f375d = ()=>{
    return (0, $eJOHy.useCallback)((componentLabelStack)=>{
        $d93500c013ebdd7b$var$ExperienceTrackerHandler.setLabelStack(componentLabelStack);
    }, []);
};
const $d93500c013ebdd7b$export$412c53791574f6f0 = (params)=>{
    (0, $gRw8I.di)((0, $9tFw2.useAnalytics));
    const { sendAnalyticsEvent: sendAnalyticsEvent, mode: conversationAssistantUIMode } = (0, $9tFw2.useAnalytics)();
    const getNameOverride = (0, $eJOHy.useCallback)((name)=>{
        switch(conversationAssistantUIMode){
            case 'mini-modal':
                return `${name}.${(0, $9KVrd.ExperienceNamePostfix).MINI_MODAL}`;
            default:
                return name;
        }
    }, [
        conversationAssistantUIMode
    ]);
    (0, $eJOHy.useMemo)(()=>{
        const experienceTracker = $d93500c013ebdd7b$var$ExperienceTrackerHandler.getInstance();
        // this is not ideal, okay just because `sendAnalyticsEvent` is never change
        // since every hook instance will override the singleton sendAnalyticsEvent
        experienceTracker.setSendAnalyticsEvent(sendAnalyticsEvent);
    }, [
        sendAnalyticsEvent
    ]);
    const experienceTrackerProxy = (0, $eJOHy.useMemo)(()=>{
        const proxyHandler = {
            get: (target, prop)=>{
                // Overriding the experienceTracker target methods to add additional attributes
                if (prop === 'fail') return (failParams)=>{
                    // Rename traceId to atlTraceId if present in attributes to distinguish from Sentry's Trace ID
                    const { traceId: traceId, ...otherAttributes } = failParams.attributes || {};
                    target.fail({
                        ...failParams,
                        attributes: {
                            ...otherAttributes,
                            ...!!traceId && {
                                atlTraceId: traceId
                            },
                            name: !!failParams.name ? getNameOverride(failParams.name) : failParams.name,
                            touchpointSource: params?.touchpointSource,
                            teamName: failParams.teamName
                        }
                    });
                };
                if (prop === 'succeed') return (succeedParams)=>{
                    target.succeed({
                        ...succeedParams,
                        name: !!succeedParams.name ? getNameOverride(succeedParams.name) : succeedParams.name,
                        attributes: {
                            ...succeedParams.attributes,
                            touchpointSource: params?.touchpointSource
                        }
                    });
                };
                if (prop === 'start') return (startParams)=>{
                    target.start({
                        ...startParams,
                        name: !!startParams.name ? getNameOverride(startParams.name) : startParams.name
                    });
                };
                if (prop === 'abort') return (abortParams)=>{
                    target.abort({
                        ...abortParams,
                        name: !!abortParams.name ? getNameOverride(abortParams.name) : abortParams.name
                    });
                };
                if (prop === 'stopOnError') return (stopOnErrorParams)=>{
                    target.stopOnError({
                        ...stopOnErrorParams,
                        name: !!stopOnErrorParams.name ? getNameOverride(stopOnErrorParams.name) : stopOnErrorParams.name
                    });
                };
                return typeof target[prop] === 'function' ? target[prop].bind(target) : target[prop];
            }
        };
        return new Proxy($d93500c013ebdd7b$var$ExperienceTrackerHandler.getInstance().experienceTracker, proxyHandler);
    }, [
        params?.touchpointSource,
        getNameOverride
    ]);
    return experienceTrackerProxy;
};

});
parcelRegister("7t81K", function(module, exports) {
$parcel$export(module.exports, "isClientFetchError", () => $ff82fc39a40f4a6e$export$2e7adc44463c3f4f);

var $eGOwo = parcelRequire("eGOwo");
// Referenced from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
const $ff82fc39a40f4a6e$var$KNOWN_NETWORK_ERRORS = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
// Issues we are not gonna track in Sentry
const $ff82fc39a40f4a6e$var$KNOWN_NETWORK_ERRORS_LIMITED = [
    'server with the specified hostname could not be found',
    'connection failure',
    'Failed to fetch',
    'Network request failed',
    'NetworkError',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted'
];
const $ff82fc39a40f4a6e$var$isClientFetchErrorMessage = (message)=>{
    const errorTypes = (0, $eGOwo.fg)('rovo_extended_error_tracking') ? $ff82fc39a40f4a6e$var$KNOWN_NETWORK_ERRORS_LIMITED : $ff82fc39a40f4a6e$var$KNOWN_NETWORK_ERRORS;
    return Boolean(message) && !!errorTypes.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
};
const $ff82fc39a40f4a6e$var$KNOWN_NETWORK_ERRORS_TYPES = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $ff82fc39a40f4a6e$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($ff82fc39a40f4a6e$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.name) || $ff82fc39a40f4a6e$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($ff82fc39a40f4a6e$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.cause.name) || $ff82fc39a40f4a6e$var$isClientFetchErrorMessage(error.cause.message)));

});

parcelRegister("aSa0e", function(module, exports) {
$parcel$export(module.exports, "setupSentryClient", () => $bd60f2015504899b$export$d8bd0edf6c978788);
$parcel$export(module.exports, "logException", () => $bd60f2015504899b$export$f86b2a1a2ce291b3);

var $27pz9 = parcelRequire("27pz9");

var $7t81K = parcelRequire("7t81K");

var $f7uih = parcelRequire("f7uih");

var $f7jiT = parcelRequire("f7jiT");

// importing local file instead of from '@sentry/browser' otherwise there will be typescript errors
const $bd60f2015504899b$var$importSentryAsync = async ()=>(parcelRequire("18Qdn"));
let $bd60f2015504899b$var$sentryClient;
// copied from platform/packages/people-and-teams/teams-client/src/services/sentry/utils/initialise-sentry.ts
const $bd60f2015504899b$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
const $bd60f2015504899b$var$getEnvironment = ()=>{
    return 'production';
};
const $bd60f2015504899b$export$d8bd0edf6c978788 = async ({ customSentryDsn: customSentryDsn, packageName: packageName, product: productOverride } = {})=>{
    let accountId = 'UNKNOWN_AAID';
    let product = productOverride ?? (0, $f7uih.getRovoChatProduct)();
    try {
        const profileData = await (0, $27pz9.performHttpFetch)({
            path: '/gateway/api/me',
            options: {
                method: 'GET'
            }
        });
        if (profileData?.account_id) accountId = profileData.account_id;
    } catch (_) {
    // do nothing
    }
    if ($bd60f2015504899b$var$sentryClient) {
        // if sentry is trying to be initialized again with new product or account id
        // update the user and tags
        $bd60f2015504899b$var$sentryClient.setTag('product', product);
        $bd60f2015504899b$var$sentryClient.setUser({
            id: accountId
        });
        // do not initialise sentry again, only update the existing one
        return;
    }
    let importedSentry;
    try {
        importedSentry = await $bd60f2015504899b$var$importSentryAsync();
    } catch (e) {
        console.warn('Failed to load conversation-assistant sentry', e); // eslint-disable-line no-console
        return;
    }
    // https://atlassian-2y.sentry.io/projects/ai-mate-conversation-assistant/getting-started/
    const defaultSentryDsn = 'https://0d679a1c0fe3816e2b2e34d4ca85d5da@o55978.ingest.sentry.io/4506794008903680';
    importedSentry.init({
        dsn: customSentryDsn || defaultSentryDsn,
        environment: $bd60f2015504899b$var$getEnvironment(),
        integrations: (integrations)=>{
            return integrations.filter((integration)=>{
                return $bd60f2015504899b$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
            });
        },
        initialScope: {
            user: {
                id: accountId
            },
            tags: {
                packageName: packageName || '@atlassian/conversation-assistant',
                product: product
            }
        },
        // referencing jira/src/packages/platform/observability/errors-handling/src/utils/sentry/handling/normalise-sentry-event.tsx
        beforeSend: (event, hint)=>{
            const exception = hint?.originalException;
            // Ignore network-like errors
            if ((0, $7t81K.isClientFetchError)(exception)) return null;
            if (!event.tags?.name) // we only want to capture errors that has `name` tag from `logException` function below
            // since the `DISABLED_INTEGRATIONS` filter above is not enough to prevent unhandled errors
            return null;
            let updatedEvent = event;
            if (updatedEvent.request?.url) {
                // Ignore events from localhost and staging
                if (updatedEvent.request.url.includes('localhost') || updatedEvent.request.url.includes('jira-dev.com') || updatedEvent.request.url.includes('stg.atlassian.com') || updatedEvent.request.url.includes('stg.internal.atlassian.com') || updatedEvent.request.url.includes('stg-east.frontend.public.atl-paas.net')) return null;
                updatedEvent.request.url = (0, $f7jiT.normaliseUrl)(updatedEvent.request.url);
            }
            if (updatedEvent.exception?.values) {
                const allMatchedUUIDs = [];
                updatedEvent.exception.values = updatedEvent.exception.values.map((exception)=>{
                    const { normalized: normalized, matchedUUIDs: matchedUUIDs } = (0, $f7jiT.normalizeUUID)(exception.value);
                    allMatchedUUIDs.push(...matchedUUIDs);
                    return {
                        ...exception,
                        value: normalized
                    };
                });
                if (allMatchedUUIDs.length > 0) {
                    if (!updatedEvent.tags) updatedEvent.tags = {};
                    updatedEvent.tags.matchedUUID = JSON.stringify(allMatchedUUIDs);
                }
            }
            return updatedEvent;
        },
        attachStacktrace: true
    });
    $bd60f2015504899b$var$sentryClient = importedSentry;
};
const $bd60f2015504899b$var$getSentryClient = async ()=>{
    if (!$bd60f2015504899b$var$sentryClient) // this only happens if something using sentry before the initialisation in root app
    await $bd60f2015504899b$export$d8bd0edf6c978788();
    return $bd60f2015504899b$var$sentryClient;
};
const $bd60f2015504899b$export$f86b2a1a2ce291b3 = async ({ exception: exception, name: name, tags: tags })=>{
    const sentryClient = await $bd60f2015504899b$var$getSentryClient();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        scope.setTag('name', name);
        if (tags) scope.setTags(tags);
        sentryClient.captureException(exception, scope);
    });
};

});
parcelRegister("27pz9", function(module, exports) {
$parcel$export(module.exports, "performHttpFetch", () => $24ccbd2e846e2db6$export$a38d93aa782475f6);
// Copied code from conversation-assistant-service/src/common/utils/fetch.ts

var $ejkJe = parcelRequire("ejkJe");

var $gkAYG = parcelRequire("gkAYG");
/**
 * Copy of this also exists in `conversation-assistant-service/src/common/utils/fetch.ts`
 */ class $24ccbd2e846e2db6$var$HttpApiError extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $24ccbd2e846e2db6$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
    try {
        const response = await fetch(path, options);
        if (!response.ok || response.status >= 400) await $24ccbd2e846e2db6$var$processHttpErrorResponse({
            response: response
        });
        return await response.json();
    } catch (err) {
        const originalErrorMessage = err instanceof Error ? 'Original error: ' + err.message : 'Unknown error';
        throw new (0, $ejkJe.FetchError)(`performHttpFetch error while fetching ${path}. ${originalErrorMessage}`, {
            errorCode: 'performHttpFetchError'
        });
    }
};
/**
 * Copy of this also exists in `conversation-assistant-service/src/common/utils/fetch.ts`
 */ const $24ccbd2e846e2db6$var$processHttpErrorResponse = async ({ response: response })=>{
    throw new $24ccbd2e846e2db6$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
        statusCode: response.status,
        traceId: (0, $gkAYG.getTraceIdFromResponse)(response)
    });
};

});
parcelRegister("ejkJe", function(module, exports) {
$parcel$export(module.exports, "FetchError", () => $9dfc13a53bb0b77b$export$26e841bcf1aeb894);
class $9dfc13a53bb0b77b$export$26e841bcf1aeb894 extends Error {
    constructor(message, errorAttributes){
        super(message), this.errorAttributes = errorAttributes;
        this.name = 'FetchError';
    }
}

});

parcelRegister("gkAYG", function(module, exports) {
$parcel$export(module.exports, "getTraceIdFromResponse", () => $4ab9c57c3ab71cd2$export$9f229e40eb65abfc);
const $4ab9c57c3ab71cd2$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-trace-id') ?? response?.headers?.get('atl-traceid') ?? response?.headers?.get('x-b3-traceid') ?? undefined;

});


parcelRegister("f7uih", function(module, exports) {
$parcel$export(module.exports, "getRovoChatProduct", () => $76b268b5cfd7eb6c$export$d4fdfa93c283ffc);
const $76b268b5cfd7eb6c$export$d4fdfa93c283ffc = ()=>{
    let product = 'UNKNOWN';
    if (window && window.__ROVO_CHAT_CONFIG_PRODUCT__) product = window.__ROVO_CHAT_CONFIG_PRODUCT__;
    return product;
};

});

parcelRegister("f7jiT", function(module, exports) {
$parcel$export(module.exports, "normaliseUrl", () => $f3d8f28d894a7ab8$export$d57ae76c6dc57a5);
$parcel$export(module.exports, "normalizeUUID", () => $f3d8f28d894a7ab8$export$5efaf8444170fe75);
const $f3d8f28d894a7ab8$var$pathnamePrefixes = [
    '/jira/',
    '/wiki/',
    '/browse/'
];
const $f3d8f28d894a7ab8$var$ATLAS_HOST = 'home.atlassian.com';
const $f3d8f28d894a7ab8$var$ATLAS_TEAM_HOST = 'team.atlassian.com';
const $f3d8f28d894a7ab8$var$UUID_REGEX = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const $f3d8f28d894a7ab8$export$d57ae76c6dc57a5 = (url)=>{
    try {
        let parsedUrl = new URL(url);
        let normalizedPath = '/any/';
        if (parsedUrl.host === $f3d8f28d894a7ab8$var$ATLAS_HOST || parsedUrl.host === $f3d8f28d894a7ab8$var$ATLAS_TEAM_HOST) // Replace org ID with "orgId" in the path
        normalizedPath = parsedUrl.pathname.replace(/\/o\/[^/]+/, '/o/orgId');
        const prefixRegex = new RegExp(`^(${$f3d8f28d894a7ab8$var$pathnamePrefixes.join('|')})`);
        if (prefixRegex.test(parsedUrl.pathname)) normalizedPath = parsedUrl.pathname.match(prefixRegex)[0];
        const normalizedUrl = `${parsedUrl.protocol}//${parsedUrl.host}${normalizedPath}`;
        return normalizedUrl;
    } catch (error) {
        return 'https://could-not-parse.example.com';
    }
};
const $f3d8f28d894a7ab8$export$5efaf8444170fe75 = (str)=>{
    if (!str) return {
        normalized: '',
        matchedUUIDs: []
    };
    const matchedUUIDs = str.match($f3d8f28d894a7ab8$var$UUID_REGEX) || [];
    const normalized = str.replace($f3d8f28d894a7ab8$var$UUID_REGEX, '{uuid}');
    return {
        normalized: normalized,
        matchedUUIDs: matchedUUIDs
    };
};

});

parcelRegister("18Qdn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kDjU6").then(()=>parcelRequire('gjZmQ'));

});



parcelRegister("anrJM", function(module, exports) {
$parcel$export(module.exports, "ModalDropdownItemTrigger", () => $bd8c6437850e43b0$export$d24aab363378eba0);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $jYYbf = parcelRequire("jYYbf");

var $asoyU = parcelRequire("asoyU");
const $bd8c6437850e43b0$export$d24aab363378eba0 = ({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, modalTitle: modalTitle, modalProps: modalProps, forwardedRef: forwardedRef, preloadOnFocus: preloadOnFocus, ...dropdownProps })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $asoyU.ModalTrigger), {
        forwardedRef: forwardedRef,
        entryPoint: entryPoint,
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        Fallback: Fallback,
        title: modalTitle,
        modalProps: modalProps,
        preloadOnFocus: preloadOnFocus,
        children: ({ ref: ref })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
                ref: ref,
                ...dropdownProps,
                children: children
            })
    });
};

});

parcelRegister("3i88T", function(module, exports) {
$parcel$export(module.exports, "jiraSmartCreationEntrypoint", () => $92a46cc2ddd2cefe$export$88c6df1f1584b969);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $92a46cc2ddd2cefe$export$88c6df1f1584b969 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("jPGEb")), {
        moduleId: "bc35c4b6",
        priority: "interaction",
        moduleId: 'async-jira-smart-creation'
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jPGEb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("kNFvF"),
    $ewTvA("fliVL"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("4th0V")
]).then(()=>parcelRequire('goQpM'));

});


parcelRegister("6Tum0", function(module, exports) {
$parcel$export(module.exports, "messages", () => $f827a31c17f1174f$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $f827a31c17f1174f$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    createWithAIItem: {
        id: 'jira-ai.create-with-ai.create-with-ai-item',
        defaultMessage: 'Create work items with Rovo',
        description: 'The text for the create work items with Rovo item in the dropdown'
    },
    dropdownLabel: {
        id: 'jira-ai.create-with-ai.dropdown-label',
        defaultMessage: 'More options',
        description: 'The label for the more options dropdown'
    }
});

});


parcelRegister("cGMXY", function(module, exports) {
$parcel$export(module.exports, "useOrgId", () => $42be11c449d1c554$export$52a03a3207af3687);

var $koAZ4 = parcelRequire("koAZ4");
const $42be11c449d1c554$export$52a03a3207af3687 = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return tenantContext && tenantContext.orgId;
};

});

// This id is required to ensure pollinator tests work between Nav3 and Nav4 and also in feature tests
const $d1eda76f6de7b0a1$export$bac9f330cf4670e8 = 'atlassian-navigation--create-button';
const $d1eda76f6de7b0a1$export$c65f84387a2a60c = 'atlassian-navigation--create-split-button';


parcelRegister("72yuq", function(module, exports) {
$parcel$export(module.exports, "GlobalIssueCreateFromTopNav", () => $9bb546db11179a36$export$177dc7755a3f80f2);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");
var $giU3c = parcelRequire("giU3c");
const $9bb546db11179a36$export$177dc7755a3f80f2 = new (0, $f39LL.UFOExperience)('global-issue-create-from-top-nav', {
    type: (0, $2lxLk.ExperienceTypes).Operation,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom,
    until: (0, $giU3c.untilAll)([
        {
            category: 'global-issue-create.create-issue'
        }
    ])
});
const $9bb546db11179a36$export$2b83859c1548ffb5 = new (0, $f39LL.UFOExperience)('projects-menu-dropdown.recommendation-selector', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
});
const $9bb546db11179a36$export$a784c5bbb21ea554 = new (0, $f39LL.UFOExperience)('projects-menu-dropdown.load-jpd-recommendation', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("9HAHw", function(module, exports) {
$parcel$export(module.exports, "default", () => $db8fb5b2eada5689$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $db8fb5b2eada5689$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    create: {
        "id": "atlassian-navigation.create.create",
        "defaultMessage": "Create"
    },
    createButtonAriaLabel: {
        "id": "atlassian-navigation.create.create-button-aria-label",
        "defaultMessage": "Create issue"
    },
    createButtonAriaLabelIssueTermRefresh: {
        "id": "atlassian-navigation.create.create-button-aria-label-issue-term-refresh",
        "defaultMessage": "Create"
    }
});

});

parcelRegister("eqj3a", function(module, exports) {
$parcel$export(module.exports, "shouldDisableGICFlagCreation", () => $ebcdc5f6d6996655$export$fc4d210bb6a1528a);

var $gRw8I = parcelRequire("gRw8I");

var $kO1ht = parcelRequire("kO1ht");
const $ebcdc5f6d6996655$export$fc4d210bb6a1528a = ()=>{
    (0, $gRw8I.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return (0, $kO1ht.JSW_TMP_BACKLOG_BOARD_REGEXP).test(window.location.pathname);
};

});


// error types
const $4246188a36de9908$export$6c8cb487d6ffc522 = 'QueryError';
const $4246188a36de9908$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $4246188a36de9908$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $4246188a36de9908$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $4246188a36de9908$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $4246188a36de9908$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $4246188a36de9908$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $4246188a36de9908$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $4246188a36de9908$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $4246188a36de9908$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $4246188a36de9908$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $4246188a36de9908$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';


$parcel$global.rlb("h7lvY")
//# sourceMappingURL=main.3db36790.js.map
